import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  TimeInHm: { input: string; output: string; }
  Upload: { input: any; output: any; }
};

export type ActivityLog = {
  __typename?: 'ActivityLog';
  activityType: ActivityType;
  actorType: ActorType;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /**
   * Metadata is a flexible JSON-based structure to store details about a logged activity.
   * It allows dynamic customization for different activity types.
   */
  metadata?: Maybe<Scalars['JSON']['output']>;
  performedBy?: Maybe<User>;
  target?: Maybe<TargetEntityUnion>;
};

export type ActivityLogCursor = {
  __typename?: 'ActivityLogCursor';
  edges: Array<ActivityLogEdge>;
  pageInfo: PageInfo;
};

export type ActivityLogEdge = {
  __typename?: 'ActivityLogEdge';
  cursor: Scalars['ID']['output'];
  node: ActivityLog;
};

export type ActivityLogFilter = {
  activityType?: InputMaybe<Array<ActivityType>>;
  actorType?: InputMaybe<Array<ActorType>>;
  dateTime?: InputMaybe<DateTimeFilter>;
  entity?: InputMaybe<Array<Entity>>;
  singleEntityFilter?: InputMaybe<SingleEntityFilter>;
};

export type ActivityLogInput = {
  cursor: CursorInput;
  filter?: InputMaybe<ActivityLogFilter>;
};

export enum ActivityType {
  Create = 'CREATE',
  Delete = 'DELETE',
  Restore = 'RESTORE',
  Update = 'UPDATE'
}

export enum ActorType {
  Admin = 'ADMIN',
  System = 'SYSTEM',
  User = 'USER'
}

export type Address = {
  __typename?: 'Address';
  buildingName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location: Location;
};

export type AddressInput = {
  buildingName?: InputMaybe<Scalars['String']['input']>;
  coordinates: GeoCoordinatesInput;
  id?: InputMaybe<Scalars['ID']['input']>;
  location: Scalars['String']['input'];
};

export enum AmountComparisonOperator {
  Between = 'BETWEEN',
  EqualTo = 'EQUAL_TO',
  GreaterThan = 'GREATER_THAN',
  LessThan = 'LESS_THAN'
}

export type AmountFilterInput = {
  BetweenAmount?: InputMaybe<BetweenAmountInput>;
  amount?: InputMaybe<MoneyInput>;
  operator: AmountComparisonOperator;
};

export enum Application {
  Admin = 'ADMIN',
  PaymentLinks = 'PAYMENT_LINKS'
}

export type Bank = {
  __typename?: 'Bank';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type BankAccount = {
  __typename?: 'BankAccount';
  accountHolder: Scalars['String']['output'];
  accountNumber: Scalars['String']['output'];
  bank: Bank;
  id: Scalars['ID']['output'];
};

export type BetweenAmountInput = {
  maxAmount: MoneyInput;
  minAmount: MoneyInput;
};

export type Business = {
  __typename?: 'Business';
  address: Address;
  balance: Array<BusinessBalance>;
  bankAccount: BankAccount;
  category: BusinessCategory;
  complianceStatus: ComplianceStatus;
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  feeProfile?: Maybe<FeeProfile>;
  id: Scalars['ID']['output'];
  /** Users associated with the business. Only has the user that submitted the form for now */
  members: Array<User>;
  name: Scalars['String']['output'];
  owner: BusinessOwner;
  phoneNumber: PhoneNumber;
  socialMedia: BusinessSocialMedia;
};


export type BusinessBalanceArgs = {
  currency?: InputMaybe<Array<CurrencyCode>>;
};

export type BusinessBalance = {
  __typename?: 'BusinessBalance';
  available: Scalars['Float']['output'];
  blocked: Scalars['Float']['output'];
  currency: CurrencyCode;
  hold: Scalars['Float']['output'];
  message?: Maybe<Scalars['String']['output']>;
  reserved: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type BusinessCategory = {
  __typename?: 'BusinessCategory';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type BusinessCursor = {
  __typename?: 'BusinessCursor';
  edges: Array<BusinessEdge>;
  pageInfo: PageInfo;
};

export type BusinessEdge = {
  __typename?: 'BusinessEdge';
  cursor: Scalars['ID']['output'];
  node: Business;
};

export type BusinessOnboarding = {
  __typename?: 'BusinessOnboarding';
  address?: Maybe<Address>;
  bankAccountBank?: Maybe<Bank>;
  bankAccountHolder?: Maybe<Scalars['String']['output']>;
  bankAccountNumber?: Maybe<Scalars['String']['output']>;
  category?: Maybe<BusinessCategory>;
  description?: Maybe<Scalars['String']['output']>;
  feeProfile?: Maybe<FeeProfile>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  ownerAddress?: Maybe<Address>;
  ownerFirstName?: Maybe<Scalars['String']['output']>;
  ownerIdPhotos?: Maybe<Array<Media>>;
  ownerIdType?: Maybe<VerificationIdType>;
  ownerLastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<PhoneNumber>;
  socialMedia?: Maybe<BusinessSocialMedia>;
  user: User;
};

export type BusinessOnboardingBankAccountInput = {
  accountHolder?: InputMaybe<Scalars['String']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  bankId?: InputMaybe<Scalars['ID']['input']>;
};

export type BusinessOnboardingInput = {
  address?: InputMaybe<AddressInput>;
  bankAccount?: InputMaybe<BusinessOnboardingBankAccountInput>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  feeProfileId?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<BusinessOnboardingOwnerInput>;
  phoneNumber?: InputMaybe<PhoneNumberInput>;
  socialMedia?: InputMaybe<BusinessOnboardingSocialMediaInput>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type BusinessOnboardingOwnerInput = {
  address?: InputMaybe<AddressInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  idPhotos?: InputMaybe<Array<Scalars['ID']['input']>>;
  idType?: InputMaybe<VerificationIdType>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type BusinessOnboardingSocialMediaInput = {
  facebook?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  /** @deprecated Field no longer supported */
  snapchat?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type BusinessOwner = {
  __typename?: 'BusinessOwner';
  address: Address;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  idPhotos: Array<Media>;
  idType: VerificationIdType;
  lastName: Scalars['String']['output'];
};

export type BusinessSocialMedia = {
  __typename?: 'BusinessSocialMedia';
  facebook?: Maybe<Scalars['String']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  /** @deprecated Field no longer supported */
  snapchat?: Maybe<Scalars['String']['output']>;
  tiktok?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type BusinessesInput = {
  cursor: CursorInput;
};

export type Card = {
  __typename?: 'Card';
  flowData?: Maybe<CardFlowData>;
  issuer?: Maybe<CardIssuer>;
  /** card no format eg ********1111 */
  number?: Maybe<Scalars['String']['output']>;
};

export type CardFlowData = {
  __typename?: 'CardFlowData';
  actionUrl?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
};

export type CardFlowDataInput = {
  actionUrl?: InputMaybe<Scalars['String']['input']>;
  referenceId?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};

export type CardInput = {
  /** card cvv format eg 123 */
  cvv?: InputMaybe<Scalars['String']['input']>;
  /** expiryMonth format eg 01 - for January to 12 - for December */
  expiryMonth?: InputMaybe<Scalars['String']['input']>;
  /** expiryYear format eg 2025 */
  expiryYear?: InputMaybe<Scalars['String']['input']>;
  flowData?: InputMaybe<CardFlowDataInput>;
  issuer?: InputMaybe<CardIssuer>;
  /** card no format eg 4111111111111111 */
  number?: InputMaybe<Scalars['String']['input']>;
};

/** CardIssuer to identity the card issuer */
export enum CardIssuer {
  Mastercard = 'MASTERCARD',
  Visa = 'VISA'
}

export enum CardSource {
  Domestic = 'DOMESTIC',
  International = 'INTERNATIONAL'
}

export enum ComplianceStatus {
  AwaitingSubmission = 'AWAITING_SUBMISSION',
  Compliant = 'COMPLIANT',
  NonCompliant = 'NON_COMPLIANT',
  Pending = 'PENDING'
}

export type CreateAdminUserInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phone: PhoneNumberInput;
  role: UserRole;
};

export type CreateRefundInput = {
  amount: MoneyInput;
  orderId: Scalars['ID']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
};

export enum CurrencyCode {
  /** Kenyan Shilling (KES). */
  Kes = 'KES',
  /** Us Dollar (USD). */
  Usd = 'USD'
}

export type CursorInput = {
  /** Going forward */
  after?: InputMaybe<Scalars['ID']['input']>;
  /** Going backwards */
  before?: InputMaybe<Scalars['ID']['input']>;
  /** Most be positive integer */
  first?: InputMaybe<Scalars['Int']['input']>;
  /** Most be positive integer */
  last?: InputMaybe<Scalars['Int']['input']>;
};

export type DateTimeFilter = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
};

export enum Entity {
  Business = 'BUSINESS',
  BusinessCategory = 'BUSINESS_CATEGORY',
  Order = 'ORDER',
  Paymentlink = 'PAYMENTLINK',
  Payout = 'PAYOUT',
  User = 'USER'
}

export type Error = {
  type: ErrorTypes;
};

export enum ErrorTypes {
  AccountLocked = 'ACCOUNT_LOCKED',
  InvalidCredentials = 'INVALID_CREDENTIALS',
  NotAuthorized = 'NOT_AUTHORIZED',
  NotFound = 'NOT_FOUND',
  NotRegistered = 'NOT_REGISTERED',
  OptInvalid = 'OPT_INVALID',
  OtpExpired = 'OTP_EXPIRED',
  /** Protected field: Only Admins and owners can access the field */
  ProtectedField = 'PROTECTED_FIELD',
  /** Service error, please retry */
  ServerError = 'SERVER_ERROR',
  TokenExpired = 'TOKEN_EXPIRED',
  TokenInvalid = 'TOKEN_INVALID',
  ValidationError = 'VALIDATION_ERROR'
}

export type FeeProfile = {
  __typename?: 'FeeProfile';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type GeoCoordinates = {
  __typename?: 'GeoCoordinates';
  lat: Scalars['Float']['output'];
  long: Scalars['Float']['output'];
};

export type GeoCoordinatesInput = {
  lat: Scalars['Float']['input'];
  long: Scalars['Float']['input'];
};

export type Image = {
  __typename?: 'Image';
  id?: Maybe<Scalars['ID']['output']>;
  large?: Maybe<Scalars['String']['output']>;
  medium?: Maybe<Scalars['String']['output']>;
  small?: Maybe<Scalars['String']['output']>;
};

export type Location = {
  __typename?: 'Location';
  coordinates: GeoCoordinates;
  formattedAddress: Scalars['String']['output'];
};

export type Login = {
  __typename?: 'Login';
  accessToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
  user: User;
};

export type LoginInput = {
  app: Application;
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type LogoutInput = {
  refreshToken: Scalars['String']['input'];
};

export type Media = {
  __typename?: 'Media';
  contentType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type Money = {
  __typename?: 'Money';
  amountInCents: Scalars['Int']['output'];
  currencyCode: CurrencyCode;
};

export type MoneyInput = {
  amountInCents: Scalars['Int']['input'];
  currencyCode: CurrencyCode;
};

export type Order = {
  __typename?: 'Order';
  card?: Maybe<Card>;
  cost: Money;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  paymentLink: PaymentLink;
  paymentMode: OrderPaymentMode;
  phoneNumber?: Maybe<PhoneNumber>;
  reference: Scalars['String']['output'];
  state: OrderState;
};

export type OrderCursor = {
  __typename?: 'OrderCursor';
  edges: Array<OrderEdge>;
  pageInfo: PageInfo;
};

export type OrderCursorInput = {
  cursor: CursorInput;
  filter?: InputMaybe<OrderFilter>;
};

export type OrderEdge = {
  __typename?: 'OrderEdge';
  cursor: Scalars['ID']['output'];
  node: Order;
};

export type OrderFilter = {
  paymentLinkId?: InputMaybe<Scalars['ID']['input']>;
  paymentMode?: InputMaybe<Array<OrderPaymentMode>>;
  states?: InputMaybe<Array<OrderState>>;
};

export type OrderInput = {
  card?: InputMaybe<CardInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  paymentLinkId: Scalars['ID']['input'];
  paymentMode: OrderPaymentMode;
  phoneNumber?: InputMaybe<PhoneNumberInput>;
};

/** OrderPaymentMode to identity method of payment for an order */
export enum OrderPaymentMode {
  Card = 'CARD',
  Mpesa = 'MPESA'
}

/** OrderState to identity the state of an order */
export enum OrderState {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor: Scalars['ID']['output'];
  entries: Scalars['Int']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPrevPage: Scalars['Boolean']['output'];
  pages: Scalars['Int']['output'];
  startCursor: Scalars['ID']['output'];
};

export type PaymentLink = {
  __typename?: 'PaymentLink';
  active: Scalars['Boolean']['output'];
  business: Business;
  cost: Money;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  /**
   * Unique reference for the payment link to be used as a shorter more user friendly string over id's UUID version
   * this will also be used as the payment link URL identifier
   */
  reference: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type PaymentLinkCursor = {
  __typename?: 'PaymentLinkCursor';
  edges: Array<PaymentLinkEdge>;
  pageInfo: PageInfo;
};

export type PaymentLinkCursorInput = {
  cursor: CursorInput;
};

export type PaymentLinkEdge = {
  __typename?: 'PaymentLinkEdge';
  cursor: Scalars['ID']['output'];
  node: PaymentLink;
};

export type PaymentLinkInput = {
  cost: MoneyInput;
  description?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

export enum PaymentProvider {
  /** Bank represents transactions processed through the Bank(PesaLink) system. */
  Bank = 'BANK',
  /** Card represents transactions processed through the Card(Cybersource) system. */
  Card = 'CARD',
  /** Manual represents transactions for manual operations */
  Manual = 'MANUAL',
  /** Mpesa represents transactions processed through the MPESA system. */
  Mpesa = 'MPESA',
  /** Unknown represents transactions has unknown value */
  Unknown = 'UNKNOWN'
}

/** Represents a payout request */
export type Payout = {
  __typename?: 'Payout';
  amount: Money;
  bankAccount?: Maybe<BankAccount>;
  business: Business;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  mobileNumber?: Maybe<PhoneNumber>;
  mode: PayoutMode;
  reference: Scalars['String']['output'];
  status: PayoutStatus;
  updatedAt: Scalars['DateTime']['output'];
};

export type PayoutConnection = {
  __typename?: 'PayoutConnection';
  edges: Array<PayoutEdge>;
  pageInfo: PageInfo;
};

export type PayoutEdge = {
  __typename?: 'PayoutEdge';
  cursor: Scalars['ID']['output'];
  node: Payout;
};

/** Input for filtering payouts */
export type PayoutFilterInput = {
  dateTime?: InputMaybe<DateTimeFilter>;
  mode?: InputMaybe<Array<PayoutMode>>;
  status?: InputMaybe<Array<PayoutStatus>>;
};

export type PayoutInput = {
  cursor: CursorInput;
  filter?: InputMaybe<PayoutFilterInput>;
};

export enum PayoutMode {
  BankTransfer = 'BANK_TRANSFER',
  Mpesa = 'MPESA'
}

export enum PayoutStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  PendingVerification = 'PENDING_VERIFICATION',
  Processing = 'PROCESSING'
}

export type PhoneNumber = {
  __typename?: 'PhoneNumber';
  countryCode: Scalars['String']['output'];
  number: Scalars['String']['output'];
};

export type PhoneNumberInput = {
  countryCode: Scalars['String']['input'];
  number: Scalars['String']['input'];
};

export type RefreshTokenInput = {
  refreshToken: Scalars['String']['input'];
};

export type Refund = {
  __typename?: 'Refund';
  amount: Money;
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  order: Order;
  reason?: Maybe<Scalars['String']['output']>;
  reference: Scalars['String']['output'];
  status: RefundStatus;
  successfulAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RefundConnection = {
  __typename?: 'RefundConnection';
  edges: Array<RefundEdge>;
  pageInfo: PageInfo;
};

export type RefundEdge = {
  __typename?: 'RefundEdge';
  cursor: Scalars['ID']['output'];
  node: Refund;
};

export type RefundFilterInput = {
  amount?: InputMaybe<AmountFilterInput>;
  dateTime?: InputMaybe<DateTimeFilter>;
  status?: InputMaybe<Array<RefundStatus>>;
};

export type RefundInput = {
  cursor: CursorInput;
  filter?: InputMaybe<RefundFilterInput>;
};

export enum RefundStatus {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  InReview = 'IN_REVIEW'
}

/** Input for requesting a new payout */
export type RequestPayoutInput = {
  amount: MoneyInput;
  bankAccountId?: InputMaybe<Scalars['ID']['input']>;
  mobileNumber?: InputMaybe<PhoneNumberInput>;
  mode: PayoutMode;
};

export type ResetPasswordInput = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type RootMutationType = {
  __typename?: 'RootMutationType';
  /** Add Order */
  addOrder: Order;
  /** Add PaymentLink */
  addPaymentLink?: Maybe<PaymentLink>;
  createAdminUser: User;
  createRefund: Refund;
  /** User login */
  login?: Maybe<Login>;
  /** Logout */
  logout?: Maybe<Scalars['Boolean']['output']>;
  /** Refresh Token */
  refreshToken?: Maybe<Login>;
  /** User requests an OTP for login */
  requestLoginOTP: Scalars['Boolean']['output'];
  /** User requests an OTP to reset password */
  requestPasswordResetOTP: Scalars['Boolean']['output'];
  /** Request a new payout */
  requestPayout: Payout;
  /** Resend Email Verification. If no email is provided we will use the auth context to figure it out. */
  resendEmailVerification: Scalars['Boolean']['output'];
  /** Resend set the admin password token link to user. */
  resendSetAdminPasswordOTP: Scalars['Boolean']['output'];
  /** Resend verification code if expired */
  sendPayoutCode: Scalars['Boolean']['output'];
  /** Set the admin password using the token provided to the user. */
  setAdminPassword: Scalars['Boolean']['output'];
  /** User registration */
  signup?: Maybe<User>;
  /** Step up Order to get the next credentials for card iframe */
  stepUpOrder: Order;
  submitBusinessOnboarding: Scalars['Boolean']['output'];
  /** Update business profile - admin only */
  updateBusiness: Business;
  updateBusinessOnboarding: BusinessOnboarding;
  /** Update the user password by providing the old and new password. */
  updatePassword: Scalars['Boolean']['output'];
  updatePaymentLink: PaymentLink;
  /** Update current or specific user */
  updateUser: User;
  uploadMedia: Media;
  /** User verifies thier OTP to reset password */
  verifyAndResetPasswordWithOTP: Scalars['Boolean']['output'];
  /** Verify Email with the token user received */
  verifyEmail: Scalars['Boolean']['output'];
  /** User verifies thier OTP to login */
  verifyLoginOTP: Login;
  /** Verify the SMS code for a payout */
  verifyPayoutCode: Payout;
};


export type RootMutationTypeAddOrderArgs = {
  input: OrderInput;
};


export type RootMutationTypeAddPaymentLinkArgs = {
  input: PaymentLinkInput;
};


export type RootMutationTypeCreateAdminUserArgs = {
  input: CreateAdminUserInput;
};


export type RootMutationTypeCreateRefundArgs = {
  input: CreateRefundInput;
};


export type RootMutationTypeLoginArgs = {
  input?: InputMaybe<LoginInput>;
};


export type RootMutationTypeLogoutArgs = {
  input?: InputMaybe<LogoutInput>;
};


export type RootMutationTypeRefreshTokenArgs = {
  input?: InputMaybe<RefreshTokenInput>;
};


export type RootMutationTypeRequestLoginOtpArgs = {
  input?: InputMaybe<LoginInput>;
};


export type RootMutationTypeRequestPasswordResetOtpArgs = {
  email: Scalars['String']['input'];
};


export type RootMutationTypeRequestPayoutArgs = {
  input: RequestPayoutInput;
};


export type RootMutationTypeResendEmailVerificationArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
};


export type RootMutationTypeResendSetAdminPasswordOtpArgs = {
  email: Scalars['String']['input'];
};


export type RootMutationTypeSendPayoutCodeArgs = {
  payoutId: Scalars['ID']['input'];
};


export type RootMutationTypeSetAdminPasswordArgs = {
  input: SetAdminPasswordInput;
};


export type RootMutationTypeSignupArgs = {
  input?: InputMaybe<SignupInput>;
};


export type RootMutationTypeStepUpOrderArgs = {
  input: OrderInput;
};


export type RootMutationTypeSubmitBusinessOnboardingArgs = {
  businessOnboardingId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootMutationTypeUpdateBusinessArgs = {
  id: Scalars['ID']['input'];
  input: BusinessOnboardingInput;
};


export type RootMutationTypeUpdateBusinessOnboardingArgs = {
  input: BusinessOnboardingInput;
};


export type RootMutationTypeUpdatePasswordArgs = {
  input: UpdatePasswordInput;
};


export type RootMutationTypeUpdatePaymentLinkArgs = {
  input: UpdatePaymentLinkInput;
};


export type RootMutationTypeUpdateUserArgs = {
  input: UpdateUserInput;
};


export type RootMutationTypeUploadMediaArgs = {
  file: Scalars['Upload']['input'];
};


export type RootMutationTypeVerifyAndResetPasswordWithOtpArgs = {
  input: ResetPasswordInput;
};


export type RootMutationTypeVerifyEmailArgs = {
  token: Scalars['String']['input'];
};


export type RootMutationTypeVerifyLoginOtpArgs = {
  code: Scalars['String']['input'];
};


export type RootMutationTypeVerifyPayoutCodeArgs = {
  input: VerifyCodeInput;
};

export type RootQueryType = {
  __typename?: 'RootQueryType';
  /** Get user by id */
  activityLog: ActivityLog;
  /** Get all activity logs with cursor based pagination */
  activityLogs: ActivityLogCursor;
  banks: Array<Bank>;
  /** Returns the business associated with the current user or specified id for admins */
  business?: Maybe<Business>;
  businessCategories: Array<BusinessCategory>;
  businessOnboarding?: Maybe<BusinessOnboarding>;
  /** Get all businesses with cursor based pagination */
  businesses: BusinessCursor;
  /** This is needed to import the error type into the Graphql docs [for Absinthee] */
  error?: Maybe<ValidationError>;
  /** There are not many fee profiles, so we can just return all of them, no need for pagination */
  feeProfiles: Array<FeeProfile>;
  /** Get current user */
  me?: Maybe<User>;
  /** Get a single order via either id or reference */
  order: Order;
  /** Get all orders belonging to a business with cursor based pagination */
  orders: OrderCursor;
  /** Get a single payment link via either id or reference */
  paymentLink: PaymentLink;
  /** Get all payment links belonging to a business with cursor based pagination */
  paymentLinks: PaymentLinkCursor;
  /** Get a single payout by ID */
  payout: Payout;
  /** Get all payouts for the authenticated user's business */
  payouts: PayoutConnection;
  refund: Refund;
  refunds: RefundConnection;
  /** Get a transaction via either id or reference */
  transaction: Transaction;
  /** Get all transactions with cursor based pagination */
  transactions: TransactionCursor;
  /** Get user by id */
  user: User;
  /** Get all users with cursor based pagination */
  users: UserCursor;
};


export type RootQueryTypeActivityLogArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeActivityLogsArgs = {
  input: ActivityLogInput;
};


export type RootQueryTypeBusinessArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeBusinessOnboardingArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type RootQueryTypeBusinessesArgs = {
  input: BusinessesInput;
};


export type RootQueryTypeOrderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeOrdersArgs = {
  input: OrderCursorInput;
};


export type RootQueryTypePaymentLinkArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypePaymentLinksArgs = {
  input: PaymentLinkCursorInput;
};


export type RootQueryTypePayoutArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypePayoutsArgs = {
  input: PayoutInput;
};


export type RootQueryTypeRefundArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
};


export type RootQueryTypeRefundsArgs = {
  input: RefundInput;
};


export type RootQueryTypeTransactionArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeTransactionsArgs = {
  input: TransactionInput;
};


export type RootQueryTypeUserArgs = {
  id: Scalars['ID']['input'];
};


export type RootQueryTypeUsersArgs = {
  input: UsersInput;
};

export type RootSubscriptionType = {
  __typename?: 'RootSubscriptionType';
  /** Same as order query but with real time updates */
  order: Order;
  /** Same as orders query but with real time updates */
  orders: OrderCursor;
  /** Get a single payment link via either id or reference */
  paymentLink: PaymentLink;
};


export type RootSubscriptionTypeOrderArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
};


export type RootSubscriptionTypeOrdersArgs = {
  input: OrderCursorInput;
};


export type RootSubscriptionTypePaymentLinkArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
};

export type SetAdminPasswordInput = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type SettlementInfo = {
  __typename?: 'SettlementInfo';
  amount?: Maybe<Money>;
  date?: Maybe<Scalars['DateTime']['output']>;
  settled?: Maybe<Scalars['Boolean']['output']>;
};

export type SignupInput = {
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  password: Scalars['String']['input'];
  phone: PhoneNumberInput;
};

export type SingleEntityFilter = {
  entity: Entity;
  id: Scalars['ID']['input'];
};

export type TargetEntityUnion = Business | BusinessCategory | Order | PaymentLink | Payout | User;

export type Transaction = {
  __typename?: 'Transaction';
  amount: Money;
  business: Business;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  fee: Money;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  paymentProvider?: Maybe<PaymentProvider>;
  reason?: Maybe<Scalars['String']['output']>;
  reference: Scalars['String']['output'];
  status: TransactionStatus;
  transactionCard?: Maybe<TransactionCard>;
  transactionMpesa?: Maybe<TransactionMpesa>;
};

export type TransactionCard = {
  __typename?: 'TransactionCard';
  cardSource?: Maybe<CardSource>;
  issuer?: Maybe<CardIssuer>;
  /** card no format eg ********1111 */
  number?: Maybe<Scalars['String']['output']>;
  settlementInfo?: Maybe<SettlementInfo>;
};

export type TransactionCursor = {
  __typename?: 'TransactionCursor';
  edges: Array<TransactionEdge>;
  pageInfo: PageInfo;
};

export type TransactionEdge = {
  __typename?: 'TransactionEdge';
  cursor: Scalars['ID']['output'];
  node: Transaction;
};

export type TransactionFilterInput = {
  dateTime?: InputMaybe<DateTimeFilter>;
  paymentProvider?: InputMaybe<Array<PaymentProvider>>;
  status?: InputMaybe<Array<TransactionStatus>>;
};

export type TransactionInput = {
  cursor: CursorInput;
  filter?: InputMaybe<TransactionFilterInput>;
};

export type TransactionMpesa = {
  __typename?: 'TransactionMpesa';
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

export enum TransactionStatus {
  Failed = 'FAILED',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export type UpdatePasswordInput = {
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};

export type UpdatePaymentLinkInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  cost?: InputMaybe<MoneyInput>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateUserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  logoId?: InputMaybe<Scalars['ID']['input']>;
  phone?: InputMaybe<PhoneNumberInput>;
  roles?: InputMaybe<Array<UserRole>>;
  status?: InputMaybe<UserStatus>;
};

export type User = {
  __typename?: 'User';
  businesses: Array<Business>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailVerifiedAt?: Maybe<Scalars['DateTime']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Image>;
  phone?: Maybe<PhoneNumber>;
  roles: Array<UserRole>;
  status: UserStatus;
};

export type UserCursor = {
  __typename?: 'UserCursor';
  edges: Array<UserEdge>;
  pageInfo: PageInfo;
};

export type UserEdge = {
  __typename?: 'UserEdge';
  cursor: Scalars['ID']['output'];
  node: User;
};

export enum UserRole {
  Admin = 'ADMIN',
  Compliance = 'COMPLIANCE',
  Finance = 'FINANCE',
  Merchant = 'MERCHANT',
  Operations = 'OPERATIONS',
  Support = 'SUPPORT'
}

export enum UserStatus {
  Active = 'ACTIVE',
  Created = 'CREATED',
  Deactivated = 'DEACTIVATED'
}

export type UsersInput = {
  cursor: CursorInput;
  roles?: InputMaybe<Array<UserRole>>;
};

export type ValidationError = Error & {
  __typename?: 'ValidationError';
  key: Scalars['String']['output'];
  /** Should give details sometimes. Example: a @cashia tag is already taken. */
  message?: Maybe<Scalars['String']['output']>;
  type: ErrorTypes;
};

/** Represents a verification code */
export type VerificationCode = {
  __typename?: 'VerificationCode';
  createdAt: Scalars['DateTime']['output'];
  expiresAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  status: VerificationCodeStatus;
};

export enum VerificationCodeStatus {
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Verified = 'VERIFIED'
}

/** Type of identity verification document */
export enum VerificationIdType {
  AlienCard = 'ALIEN_CARD',
  NationalId = 'NATIONAL_ID',
  Passport = 'PASSPORT'
}

/** Input for verifying a code */
export type VerifyCodeInput = {
  code: Scalars['String']['input'];
  payoutId: Scalars['ID']['input'];
};

export type ActivityLogFieldsFragment = { __typename?: 'ActivityLog', id: string, description: string, createdAt: any, actorType: ActorType, activityType: ActivityType, metadata?: any | null, performedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null, businesses: Array<{ __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> }> } | null, target?: { __typename?: 'Business', name: string } | { __typename?: 'BusinessCategory', name: string } | { __typename?: 'Order', id: string, reference: string } | { __typename?: 'PaymentLink', id: string, title: string } | { __typename?: 'Payout', id: string, business: { __typename?: 'Business', name: string } } | { __typename?: 'User', firstName?: string | null, lastName?: string | null, roles: Array<UserRole> } | null };

export type ActivityLogEdgeFieldsFragment = { __typename?: 'ActivityLogEdge', cursor: string, node: { __typename?: 'ActivityLog', id: string, description: string, createdAt: any, actorType: ActorType, activityType: ActivityType, metadata?: any | null, performedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null, businesses: Array<{ __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> }> } | null, target?: { __typename?: 'Business', name: string } | { __typename?: 'BusinessCategory', name: string } | { __typename?: 'Order', id: string, reference: string } | { __typename?: 'PaymentLink', id: string, title: string } | { __typename?: 'Payout', id: string, business: { __typename?: 'Business', name: string } } | { __typename?: 'User', firstName?: string | null, lastName?: string | null, roles: Array<UserRole> } | null } };

export type ActivityLogCursorFieldsFragment = { __typename?: 'ActivityLogCursor', edges: Array<{ __typename?: 'ActivityLogEdge', cursor: string, node: { __typename?: 'ActivityLog', id: string, description: string, createdAt: any, actorType: ActorType, activityType: ActivityType, metadata?: any | null, performedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null, businesses: Array<{ __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> }> } | null, target?: { __typename?: 'Business', name: string } | { __typename?: 'BusinessCategory', name: string } | { __typename?: 'Order', id: string, reference: string } | { __typename?: 'PaymentLink', id: string, title: string } | { __typename?: 'Payout', id: string, business: { __typename?: 'Business', name: string } } | { __typename?: 'User', firstName?: string | null, lastName?: string | null, roles: Array<UserRole> } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPrevPage: boolean, startCursor: string, endCursor: string, entries: number, pages: number } };

type TargetEntityFragmentBusinessFragment = { __typename?: 'Business', name: string };

type TargetEntityFragmentBusinessCategoryFragment = { __typename?: 'BusinessCategory', name: string };

type TargetEntityFragmentOrderFragment = { __typename?: 'Order', id: string, reference: string };

type TargetEntityFragmentPaymentLinkFragment = { __typename?: 'PaymentLink', id: string, title: string };

type TargetEntityFragmentPayoutFragment = { __typename?: 'Payout', id: string, business: { __typename?: 'Business', name: string } };

type TargetEntityFragmentUserFragment = { __typename?: 'User', firstName?: string | null, lastName?: string | null, roles: Array<UserRole> };

export type TargetEntityFragmentFragment = TargetEntityFragmentBusinessFragment | TargetEntityFragmentBusinessCategoryFragment | TargetEntityFragmentOrderFragment | TargetEntityFragmentPaymentLinkFragment | TargetEntityFragmentPayoutFragment | TargetEntityFragmentUserFragment;

export type GeoCoordinatesFieldsFragment = { __typename?: 'GeoCoordinates', lat: number, long: number };

export type LocationFieldsFragment = { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } };

export type AddressFieldsFragment = { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } };

export type BusinessOwnerFieldsFragment = { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } };

export type BusinessCategoryFieldsFragment = { __typename?: 'BusinessCategory', id: string, name: string, code: string };

export type BusinessSocialMediaFieldsFragment = { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null };

export type BanksFieldsFragment = { __typename?: 'Bank', id: string, name: string };

export type BankAccountFieldsFragment = { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } };

export type BusinessBalanceFieldsFragment = { __typename?: 'BusinessBalance', currency: CurrencyCode, hold: number, available: number, reserved: number, blocked: number, total: number, message?: string | null };

export type BusinessFieldsFragment = { __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> };

export type BusinessFieldsWithFeeProfilesFragment = { __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, feeProfile?: { __typename?: 'FeeProfile', id: string, code: string, name: string } | null, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> };

export type BusinessEdgeFieldsFragment = { __typename?: 'BusinessEdge', cursor: string, node: { __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, feeProfile?: { __typename?: 'FeeProfile', id: string, code: string, name: string } | null, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> } };

export type BusinessCursorFieldsFragment = { __typename?: 'BusinessCursor', edges: Array<{ __typename?: 'BusinessEdge', cursor: string, node: { __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, feeProfile?: { __typename?: 'FeeProfile', id: string, code: string, name: string } | null, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPrevPage: boolean, startCursor: string, endCursor: string, entries: number, pages: number } };

export type BusinessOnboardingFieldsFragment = { __typename?: 'BusinessOnboarding', id: string, name?: string | null, description?: string | null, ownerFirstName?: string | null, ownerLastName?: string | null, ownerIdType?: VerificationIdType | null, bankAccountHolder?: string | null, bankAccountNumber?: string | null, category?: { __typename?: 'BusinessCategory', id: string, name: string, code: string } | null, phoneNumber?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null, address?: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } | null, ownerIdPhotos?: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }> | null, ownerAddress?: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } | null, bankAccountBank?: { __typename?: 'Bank', id: string, name: string } | null, socialMedia?: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null } | null };

export type CardFLowFieldsFragment = { __typename?: 'CardFlowData', actionUrl?: string | null, referenceId?: string | null, token?: string | null };

export type CardFieldsFragment = { __typename?: 'Card', number?: string | null, issuer?: CardIssuer | null, flowData?: { __typename?: 'CardFlowData', actionUrl?: string | null, referenceId?: string | null, token?: string | null } | null };

export type MoneyFieldsFragment = { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode };

export type OrderFieldsFragment = { __typename?: 'Order', id: string, message?: string | null, reference: string, firstName?: string | null, lastName?: string | null, paymentMode: OrderPaymentMode, state: OrderState, createdAt?: any | null, cost: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, paymentLink: { __typename?: 'PaymentLink', id: string, title: string, description?: string | null, active: boolean, reference: string, createdAt?: any | null, limit?: number | null, cost: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, business: { __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> } }, phoneNumber?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null, card?: { __typename?: 'Card', number?: string | null, issuer?: CardIssuer | null, flowData?: { __typename?: 'CardFlowData', actionUrl?: string | null, referenceId?: string | null, token?: string | null } | null } | null };

export type OrderEdgeFieldsFragment = { __typename?: 'OrderEdge', cursor: string, node: { __typename?: 'Order', id: string, message?: string | null, reference: string, firstName?: string | null, lastName?: string | null, paymentMode: OrderPaymentMode, state: OrderState, createdAt?: any | null, cost: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, paymentLink: { __typename?: 'PaymentLink', id: string, title: string, description?: string | null, active: boolean, reference: string, createdAt?: any | null, limit?: number | null, cost: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, business: { __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> } }, phoneNumber?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null, card?: { __typename?: 'Card', number?: string | null, issuer?: CardIssuer | null, flowData?: { __typename?: 'CardFlowData', actionUrl?: string | null, referenceId?: string | null, token?: string | null } | null } | null } };

export type OrderCursorFieldsFragment = { __typename?: 'OrderCursor', edges: Array<{ __typename?: 'OrderEdge', cursor: string, node: { __typename?: 'Order', id: string, message?: string | null, reference: string, firstName?: string | null, lastName?: string | null, paymentMode: OrderPaymentMode, state: OrderState, createdAt?: any | null, cost: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, paymentLink: { __typename?: 'PaymentLink', id: string, title: string, description?: string | null, active: boolean, reference: string, createdAt?: any | null, limit?: number | null, cost: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, business: { __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> } }, phoneNumber?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null, card?: { __typename?: 'Card', number?: string | null, issuer?: CardIssuer | null, flowData?: { __typename?: 'CardFlowData', actionUrl?: string | null, referenceId?: string | null, token?: string | null } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPrevPage: boolean, startCursor: string, endCursor: string, entries: number, pages: number } };

export type PaymentLinkFieldsFragment = { __typename?: 'PaymentLink', id: string, title: string, description?: string | null, active: boolean, reference: string, createdAt?: any | null, limit?: number | null, cost: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, business: { __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> } };

export type PaymentLinkEdgeFieldsFragment = { __typename?: 'PaymentLinkEdge', cursor: string, node: { __typename?: 'PaymentLink', id: string, title: string, description?: string | null, active: boolean, reference: string, createdAt?: any | null, limit?: number | null, cost: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, business: { __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> } } };

export type PaymentLinkCursorFieldsFragment = { __typename?: 'PaymentLinkCursor', edges: Array<{ __typename?: 'PaymentLinkEdge', cursor: string, node: { __typename?: 'PaymentLink', id: string, title: string, description?: string | null, active: boolean, reference: string, createdAt?: any | null, limit?: number | null, cost: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, business: { __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPrevPage: boolean, startCursor: string, endCursor: string, entries: number, pages: number } };

export type PayoutFieldsFragment = { __typename?: 'Payout', id: string, reference: string, status: PayoutStatus, mode: PayoutMode, createdAt: any, updatedAt: any, message?: string | null, amount: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, bankAccount?: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } } | null, mobileNumber?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null, business: { __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> } };

export type PayoutEdgeFieldsFragment = { __typename?: 'PayoutEdge', cursor: string, node: { __typename?: 'Payout', id: string, reference: string, status: PayoutStatus, mode: PayoutMode, createdAt: any, updatedAt: any, message?: string | null, amount: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, bankAccount?: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } } | null, mobileNumber?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null, business: { __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> } } };

export type PayoutConnectionFieldsFragment = { __typename?: 'PayoutConnection', edges: Array<{ __typename?: 'PayoutEdge', cursor: string, node: { __typename?: 'Payout', id: string, reference: string, status: PayoutStatus, mode: PayoutMode, createdAt: any, updatedAt: any, message?: string | null, amount: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, bankAccount?: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } } | null, mobileNumber?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null, business: { __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPrevPage: boolean, startCursor: string, endCursor: string, entries: number, pages: number } };

export type PhoneNumberFieldsFragment = { __typename?: 'PhoneNumber', number: string, countryCode: string };

export type RefundFieldsFragment = { __typename?: 'Refund', id: string, reason?: string | null, reference: string, status: RefundStatus, createdAt: any, amount: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, order: { __typename?: 'Order', id: string, message?: string | null, reference: string, firstName?: string | null, lastName?: string | null, paymentMode: OrderPaymentMode, state: OrderState, createdAt?: any | null, cost: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, paymentLink: { __typename?: 'PaymentLink', id: string, title: string, description?: string | null, active: boolean, reference: string, createdAt?: any | null, limit?: number | null, cost: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, business: { __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> } }, phoneNumber?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null, card?: { __typename?: 'Card', number?: string | null, issuer?: CardIssuer | null, flowData?: { __typename?: 'CardFlowData', actionUrl?: string | null, referenceId?: string | null, token?: string | null } | null } | null } };

export type RefundEdgeFieldsFragment = { __typename?: 'RefundEdge', cursor: string, node: { __typename?: 'Refund', id: string, reason?: string | null, reference: string, status: RefundStatus, createdAt: any, amount: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, order: { __typename?: 'Order', id: string, message?: string | null, reference: string, firstName?: string | null, lastName?: string | null, paymentMode: OrderPaymentMode, state: OrderState, createdAt?: any | null, cost: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, paymentLink: { __typename?: 'PaymentLink', id: string, title: string, description?: string | null, active: boolean, reference: string, createdAt?: any | null, limit?: number | null, cost: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, business: { __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> } }, phoneNumber?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null, card?: { __typename?: 'Card', number?: string | null, issuer?: CardIssuer | null, flowData?: { __typename?: 'CardFlowData', actionUrl?: string | null, referenceId?: string | null, token?: string | null } | null } | null } } };

export type RefundConnectionFieldsFragment = { __typename?: 'RefundConnection', edges: Array<{ __typename?: 'RefundEdge', cursor: string, node: { __typename?: 'Refund', id: string, reason?: string | null, reference: string, status: RefundStatus, createdAt: any, amount: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, order: { __typename?: 'Order', id: string, message?: string | null, reference: string, firstName?: string | null, lastName?: string | null, paymentMode: OrderPaymentMode, state: OrderState, createdAt?: any | null, cost: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, paymentLink: { __typename?: 'PaymentLink', id: string, title: string, description?: string | null, active: boolean, reference: string, createdAt?: any | null, limit?: number | null, cost: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, business: { __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> } }, phoneNumber?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null, card?: { __typename?: 'Card', number?: string | null, issuer?: CardIssuer | null, flowData?: { __typename?: 'CardFlowData', actionUrl?: string | null, referenceId?: string | null, token?: string | null } | null } | null } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPrevPage: boolean, startCursor: string, endCursor: string, entries: number, pages: number } };

export type UserFieldsFragment = { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null, businesses: Array<{ __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> }> };

export type UserEdgeFieldsFragment = { __typename?: 'UserEdge', cursor: string, node: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null, businesses: Array<{ __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> }> } };

export type UserCursorFieldsFragment = { __typename?: 'UserCursor', edges: Array<{ __typename?: 'UserEdge', cursor: string, node: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null, businesses: Array<{ __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPrevPage: boolean, startCursor: string, endCursor: string, entries: number, pages: number } };

export type CreateAdminUserMutationVariables = Exact<{
  input: CreateAdminUserInput;
}>;


export type CreateAdminUserMutation = { __typename?: 'RootMutationType', createAdminUser: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null, businesses: Array<{ __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> }> } };

export type RequestLoginOtpMutationVariables = Exact<{
  input: LoginInput;
}>;


export type RequestLoginOtpMutation = { __typename?: 'RootMutationType', requestLoginOTP: boolean };

export type VerifyLoginOtpMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type VerifyLoginOtpMutation = { __typename?: 'RootMutationType', verifyLoginOTP: { __typename?: 'Login', accessToken: string, refreshToken: string, user: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null, businesses: Array<{ __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> }> } } };

export type RefreshTokenMutationVariables = Exact<{
  input: RefreshTokenInput;
}>;


export type RefreshTokenMutation = { __typename?: 'RootMutationType', refreshToken?: { __typename?: 'Login', accessToken: string, refreshToken: string } | null };

export type ResendSetAdminPasswordOtpMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ResendSetAdminPasswordOtpMutation = { __typename?: 'RootMutationType', resendSetAdminPasswordOTP: boolean };

export type RequestPasswordResetOtpMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type RequestPasswordResetOtpMutation = { __typename?: 'RootMutationType', requestPasswordResetOTP: boolean };

export type SetPasswordMutationVariables = Exact<{
  input: SetAdminPasswordInput;
}>;


export type SetPasswordMutation = { __typename?: 'RootMutationType', setAdminPassword: boolean };

export type SignupMutationVariables = Exact<{
  input: SignupInput;
}>;


export type SignupMutation = { __typename?: 'RootMutationType', signup?: { __typename?: 'User', firstName?: string | null, lastName?: string | null, id?: string | null, email?: string | null, createdAt?: any | null, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null } | null };

export type SubmitBusinessOnboardingMutationVariables = Exact<{
  businessOnboardingId: Scalars['ID']['input'];
}>;


export type SubmitBusinessOnboardingMutation = { __typename?: 'RootMutationType', submitBusinessOnboarding: boolean };

export type UpdateBusinessDetailsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: BusinessOnboardingInput;
}>;


export type UpdateBusinessDetailsMutation = { __typename?: 'RootMutationType', updateBusiness: { __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> } };

export type UpdateBusinessOnboardingMutationVariables = Exact<{
  input: BusinessOnboardingInput;
}>;


export type UpdateBusinessOnboardingMutation = { __typename?: 'RootMutationType', updateBusinessOnboarding: { __typename?: 'BusinessOnboarding', id: string, name?: string | null, description?: string | null, ownerFirstName?: string | null, ownerLastName?: string | null, ownerIdType?: VerificationIdType | null, bankAccountHolder?: string | null, bankAccountNumber?: string | null, category?: { __typename?: 'BusinessCategory', id: string, name: string, code: string } | null, phoneNumber?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null, address?: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } | null, ownerIdPhotos?: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }> | null, ownerAddress?: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } | null, bankAccountBank?: { __typename?: 'Bank', id: string, name: string } | null, socialMedia?: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null } | null } };

export type UpdatePasswordMutationVariables = Exact<{
  input: UpdatePasswordInput;
}>;


export type UpdatePasswordMutation = { __typename?: 'RootMutationType', updatePassword: boolean };

export type UpdateUserDetailsMutationVariables = Exact<{
  input: UpdateUserInput;
}>;


export type UpdateUserDetailsMutation = { __typename?: 'RootMutationType', updateUser: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null, businesses: Array<{ __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> }> } };

export type UploadMediaMutationVariables = Exact<{
  file: Scalars['Upload']['input'];
}>;


export type UploadMediaMutation = { __typename?: 'RootMutationType', uploadMedia: { __typename?: 'Media', id: string } };

export type VerifyAndResetPasswordWithOtpMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type VerifyAndResetPasswordWithOtpMutation = { __typename?: 'RootMutationType', verifyAndResetPasswordWithOTP: boolean };

export type GetActivityLogsQueryVariables = Exact<{
  input: ActivityLogInput;
}>;


export type GetActivityLogsQuery = { __typename?: 'RootQueryType', activityLogs: { __typename?: 'ActivityLogCursor', edges: Array<{ __typename?: 'ActivityLogEdge', cursor: string, node: { __typename?: 'ActivityLog', id: string, description: string, createdAt: any, actorType: ActorType, activityType: ActivityType, metadata?: any | null, performedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null, businesses: Array<{ __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> }> } | null, target?: { __typename?: 'Business', name: string } | { __typename?: 'BusinessCategory', name: string } | { __typename?: 'Order', id: string, reference: string } | { __typename?: 'PaymentLink', id: string, title: string } | { __typename?: 'Payout', id: string, business: { __typename?: 'Business', name: string } } | { __typename?: 'User', firstName?: string | null, lastName?: string | null, roles: Array<UserRole> } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPrevPage: boolean, startCursor: string, endCursor: string, entries: number, pages: number } } };

export type GetActivityLogQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetActivityLogQuery = { __typename?: 'RootQueryType', activityLog: { __typename?: 'ActivityLog', id: string, description: string, createdAt: any, actorType: ActorType, activityType: ActivityType, metadata?: any | null, performedBy?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null, businesses: Array<{ __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> }> } | null, target?: { __typename?: 'Business', name: string } | { __typename?: 'BusinessCategory', name: string } | { __typename?: 'Order', id: string, reference: string } | { __typename?: 'PaymentLink', id: string, title: string } | { __typename?: 'Payout', id: string, business: { __typename?: 'Business', name: string } } | { __typename?: 'User', firstName?: string | null, lastName?: string | null, roles: Array<UserRole> } | null } };

export type GetBanksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBanksQuery = { __typename?: 'RootQueryType', banks: Array<{ __typename?: 'Bank', id: string, name: string }> };

export type GetBusinessQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  currency?: InputMaybe<Array<CurrencyCode> | CurrencyCode>;
}>;


export type GetBusinessQuery = { __typename?: 'RootQueryType', business?: { __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, balance: Array<{ __typename?: 'BusinessBalance', currency: CurrencyCode, hold: number, available: number, reserved: number, blocked: number, total: number, message?: string | null }>, feeProfile?: { __typename?: 'FeeProfile', id: string, code: string, name: string } | null, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> } | null };

export type GetBusinessCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBusinessCategoriesQuery = { __typename?: 'RootQueryType', businessCategories: Array<{ __typename?: 'BusinessCategory', id: string, name: string, code: string }> };

export type GetBusinessesQueryVariables = Exact<{
  input: BusinessesInput;
}>;


export type GetBusinessesQuery = { __typename?: 'RootQueryType', businesses: { __typename?: 'BusinessCursor', edges: Array<{ __typename?: 'BusinessEdge', cursor: string, node: { __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, feeProfile?: { __typename?: 'FeeProfile', id: string, code: string, name: string } | null, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPrevPage: boolean, startCursor: string, endCursor: string, entries: number, pages: number } } };

export type GetFeeProfilesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeeProfilesQuery = { __typename?: 'RootQueryType', feeProfiles: Array<{ __typename?: 'FeeProfile', id: string, name: string, code: string }> };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'RootQueryType', me?: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null, businesses: Array<{ __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> }> } | null };

export type GetOrderQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrderQuery = { __typename?: 'RootQueryType', order: { __typename?: 'Order', id: string, message?: string | null, reference: string, firstName?: string | null, lastName?: string | null, paymentMode: OrderPaymentMode, state: OrderState, createdAt?: any | null, cost: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, paymentLink: { __typename?: 'PaymentLink', id: string, title: string, description?: string | null, active: boolean, reference: string, createdAt?: any | null, limit?: number | null, cost: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, business: { __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> } }, phoneNumber?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null, card?: { __typename?: 'Card', number?: string | null, issuer?: CardIssuer | null, flowData?: { __typename?: 'CardFlowData', actionUrl?: string | null, referenceId?: string | null, token?: string | null } | null } | null } };

export type GetOrdersQueryVariables = Exact<{
  input: OrderCursorInput;
}>;


export type GetOrdersQuery = { __typename?: 'RootQueryType', orders: { __typename?: 'OrderCursor', edges: Array<{ __typename?: 'OrderEdge', cursor: string, node: { __typename?: 'Order', id: string, message?: string | null, reference: string, firstName?: string | null, lastName?: string | null, paymentMode: OrderPaymentMode, state: OrderState, createdAt?: any | null, cost: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, paymentLink: { __typename?: 'PaymentLink', id: string, title: string, description?: string | null, active: boolean, reference: string, createdAt?: any | null, limit?: number | null, cost: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, business: { __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> } }, phoneNumber?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null, card?: { __typename?: 'Card', number?: string | null, issuer?: CardIssuer | null, flowData?: { __typename?: 'CardFlowData', actionUrl?: string | null, referenceId?: string | null, token?: string | null } | null } | null } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPrevPage: boolean, startCursor: string, endCursor: string, entries: number, pages: number } } };

export type GetPayoutQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPayoutQuery = { __typename?: 'RootQueryType', payout: { __typename?: 'Payout', id: string, reference: string, status: PayoutStatus, mode: PayoutMode, createdAt: any, updatedAt: any, message?: string | null, amount: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, bankAccount?: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } } | null, mobileNumber?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null, business: { __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> } } };

export type GetPayoutsQueryVariables = Exact<{
  input: PayoutInput;
}>;


export type GetPayoutsQuery = { __typename?: 'RootQueryType', payouts: { __typename?: 'PayoutConnection', edges: Array<{ __typename?: 'PayoutEdge', cursor: string, node: { __typename?: 'Payout', id: string, reference: string, status: PayoutStatus, mode: PayoutMode, createdAt: any, updatedAt: any, message?: string | null, amount: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, bankAccount?: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } } | null, mobileNumber?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null, business: { __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPrevPage: boolean, startCursor: string, endCursor: string, entries: number, pages: number } } };

export type GetRefundQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetRefundQuery = { __typename?: 'RootQueryType', refund: { __typename?: 'Refund', id: string, reason?: string | null, reference: string, status: RefundStatus, createdAt: any, amount: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, order: { __typename?: 'Order', id: string, message?: string | null, reference: string, firstName?: string | null, lastName?: string | null, paymentMode: OrderPaymentMode, state: OrderState, createdAt?: any | null, cost: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, paymentLink: { __typename?: 'PaymentLink', id: string, title: string, description?: string | null, active: boolean, reference: string, createdAt?: any | null, limit?: number | null, cost: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, business: { __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> } }, phoneNumber?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null, card?: { __typename?: 'Card', number?: string | null, issuer?: CardIssuer | null, flowData?: { __typename?: 'CardFlowData', actionUrl?: string | null, referenceId?: string | null, token?: string | null } | null } | null } } };

export type GetRefundsQueryVariables = Exact<{
  input: RefundInput;
}>;


export type GetRefundsQuery = { __typename?: 'RootQueryType', refunds: { __typename?: 'RefundConnection', edges: Array<{ __typename?: 'RefundEdge', cursor: string, node: { __typename?: 'Refund', id: string, reason?: string | null, reference: string, status: RefundStatus, createdAt: any, amount: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, order: { __typename?: 'Order', id: string, message?: string | null, reference: string, firstName?: string | null, lastName?: string | null, paymentMode: OrderPaymentMode, state: OrderState, createdAt?: any | null, cost: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, paymentLink: { __typename?: 'PaymentLink', id: string, title: string, description?: string | null, active: boolean, reference: string, createdAt?: any | null, limit?: number | null, cost: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, business: { __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> } }, phoneNumber?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null, card?: { __typename?: 'Card', number?: string | null, issuer?: CardIssuer | null, flowData?: { __typename?: 'CardFlowData', actionUrl?: string | null, referenceId?: string | null, token?: string | null } | null } | null } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPrevPage: boolean, startCursor: string, endCursor: string, entries: number, pages: number } } };

export type TransactionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TransactionQuery = { __typename?: 'RootQueryType', transaction: { __typename?: 'Transaction', id: string, status: TransactionStatus, message?: string | null, createdAt?: any | null, paymentProvider?: PaymentProvider | null, amount: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode }, business: { __typename?: 'Business', id: string, name: string }, transactionCard?: { __typename?: 'TransactionCard', number?: string | null, issuer?: CardIssuer | null, cardSource?: CardSource | null, settlementInfo?: { __typename?: 'SettlementInfo', settled?: boolean | null, date?: any | null, amount?: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } | null } | null } | null, transactionMpesa?: { __typename?: 'TransactionMpesa', phoneNumber?: string | null } | null, fee: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } } };

export type TransactionsQueryVariables = Exact<{
  input: TransactionInput;
}>;


export type TransactionsQuery = { __typename?: 'RootQueryType', transactions: { __typename?: 'TransactionCursor', edges: Array<{ __typename?: 'TransactionEdge', node: { __typename?: 'Transaction', id: string, createdAt?: any | null, paymentProvider?: PaymentProvider | null, status: TransactionStatus, business: { __typename?: 'Business', id: string, name: string }, transactionCard?: { __typename?: 'TransactionCard', issuer?: CardIssuer | null } | null, amount: { __typename?: 'Money', amountInCents: number, currencyCode: CurrencyCode } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPrevPage: boolean, startCursor: string, endCursor: string, entries: number, pages: number } } };

export type GetUserQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetUserQuery = { __typename?: 'RootQueryType', user: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null, businesses: Array<{ __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> }> } };

export type GetUsersQueryVariables = Exact<{
  input: UsersInput;
}>;


export type GetUsersQuery = { __typename?: 'RootQueryType', users: { __typename?: 'UserCursor', edges: Array<{ __typename?: 'UserEdge', cursor: string, node: { __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null, businesses: Array<{ __typename?: 'Business', id: string, name: string, description: string, complianceStatus: ComplianceStatus, createdAt: any, owner: { __typename?: 'BusinessOwner', id: string, firstName: string, lastName: string, idType: VerificationIdType, idPhotos: Array<{ __typename?: 'Media', id: string, url: string, contentType: string }>, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } } }, phoneNumber: { __typename?: 'PhoneNumber', number: string, countryCode: string }, category: { __typename?: 'BusinessCategory', id: string, name: string, code: string }, address: { __typename?: 'Address', id: string, buildingName?: string | null, location: { __typename?: 'Location', formattedAddress: string, coordinates: { __typename?: 'GeoCoordinates', lat: number, long: number } } }, socialMedia: { __typename?: 'BusinessSocialMedia', website?: string | null, facebook?: string | null, instagram?: string | null, tiktok?: string | null }, bankAccount: { __typename?: 'BankAccount', id: string, accountHolder: string, accountNumber: string, bank: { __typename?: 'Bank', id: string, name: string } }, members: Array<{ __typename?: 'User', id?: string | null, firstName?: string | null, lastName?: string | null, email?: string | null, createdAt?: any | null, status: UserStatus, emailVerifiedAt?: any | null, roles: Array<UserRole>, phone?: { __typename?: 'PhoneNumber', number: string, countryCode: string } | null }> }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPrevPage: boolean, startCursor: string, endCursor: string, entries: number, pages: number } } };

export const PhoneNumberFieldsFragmentDoc = gql`
    fragment phoneNumberFields on PhoneNumber {
  number
  countryCode
}
    `;
export const GeoCoordinatesFieldsFragmentDoc = gql`
    fragment geoCoordinatesFields on GeoCoordinates {
  lat
  long
}
    `;
export const LocationFieldsFragmentDoc = gql`
    fragment locationFields on Location {
  formattedAddress
  coordinates {
    ...geoCoordinatesFields
  }
}
    ${GeoCoordinatesFieldsFragmentDoc}`;
export const AddressFieldsFragmentDoc = gql`
    fragment addressFields on Address {
  id
  location {
    ...locationFields
  }
  buildingName
}
    ${LocationFieldsFragmentDoc}`;
export const BusinessOwnerFieldsFragmentDoc = gql`
    fragment businessOwnerFields on BusinessOwner {
  id
  firstName
  lastName
  idType
  idPhotos {
    id
    url
    contentType
  }
  address {
    ...addressFields
  }
}
    ${AddressFieldsFragmentDoc}`;
export const BusinessCategoryFieldsFragmentDoc = gql`
    fragment businessCategoryFields on BusinessCategory {
  id
  name
  code
}
    `;
export const BusinessSocialMediaFieldsFragmentDoc = gql`
    fragment businessSocialMediaFields on BusinessSocialMedia {
  website
  facebook
  instagram
  tiktok
}
    `;
export const BanksFieldsFragmentDoc = gql`
    fragment banksFields on Bank {
  id
  name
}
    `;
export const BankAccountFieldsFragmentDoc = gql`
    fragment bankAccountFields on BankAccount {
  id
  bank {
    ...banksFields
  }
  accountHolder
  accountNumber
}
    ${BanksFieldsFragmentDoc}`;
export const BusinessFieldsFragmentDoc = gql`
    fragment businessFields on Business {
  id
  name
  description
  owner {
    ...businessOwnerFields
  }
  phoneNumber {
    ...phoneNumberFields
  }
  category {
    ...businessCategoryFields
  }
  address {
    ...addressFields
  }
  socialMedia {
    ...businessSocialMediaFields
  }
  bankAccount {
    ...bankAccountFields
  }
  complianceStatus
  createdAt
  members {
    id
    firstName
    lastName
    email
    createdAt
    status
    emailVerifiedAt
    roles
    phone {
      ...phoneNumberFields
    }
  }
}
    ${BusinessOwnerFieldsFragmentDoc}
${PhoneNumberFieldsFragmentDoc}
${BusinessCategoryFieldsFragmentDoc}
${AddressFieldsFragmentDoc}
${BusinessSocialMediaFieldsFragmentDoc}
${BankAccountFieldsFragmentDoc}`;
export const UserFieldsFragmentDoc = gql`
    fragment userFields on User {
  id
  firstName
  lastName
  email
  phone {
    ...phoneNumberFields
  }
  createdAt
  status
  emailVerifiedAt
  roles
  businesses {
    ...businessFields
  }
}
    ${PhoneNumberFieldsFragmentDoc}
${BusinessFieldsFragmentDoc}`;
export const TargetEntityFragmentFragmentDoc = gql`
    fragment targetEntityFragment on TargetEntityUnion {
  ... on User {
    firstName
    lastName
    roles
  }
  ... on Business {
    name
  }
  ... on BusinessCategory {
    name
  }
  ... on Order {
    id
    reference
  }
  ... on Payout {
    id
    business {
      name
    }
  }
  ... on PaymentLink {
    id
    title
  }
}
    `;
export const ActivityLogFieldsFragmentDoc = gql`
    fragment activityLogFields on ActivityLog {
  id
  description
  createdAt
  performedBy {
    ...userFields
  }
  actorType
  activityType
  target {
    ...targetEntityFragment
  }
  metadata
}
    ${UserFieldsFragmentDoc}
${TargetEntityFragmentFragmentDoc}`;
export const ActivityLogEdgeFieldsFragmentDoc = gql`
    fragment activityLogEdgeFields on ActivityLogEdge {
  cursor
  node {
    ...activityLogFields
  }
}
    ${ActivityLogFieldsFragmentDoc}`;
export const ActivityLogCursorFieldsFragmentDoc = gql`
    fragment activityLogCursorFields on ActivityLogCursor {
  edges {
    ...activityLogEdgeFields
  }
  pageInfo {
    hasNextPage
    hasPrevPage
    startCursor
    endCursor
    entries
    pages
  }
}
    ${ActivityLogEdgeFieldsFragmentDoc}`;
export const BusinessBalanceFieldsFragmentDoc = gql`
    fragment businessBalanceFields on BusinessBalance {
  currency
  hold
  available
  reserved
  blocked
  total
  message
}
    `;
export const BusinessFieldsWithFeeProfilesFragmentDoc = gql`
    fragment businessFieldsWithFeeProfiles on Business {
  ...businessFields
  feeProfile {
    id
    code
    name
  }
}
    ${BusinessFieldsFragmentDoc}`;
export const BusinessEdgeFieldsFragmentDoc = gql`
    fragment businessEdgeFields on BusinessEdge {
  cursor
  node {
    ...businessFieldsWithFeeProfiles
  }
}
    ${BusinessFieldsWithFeeProfilesFragmentDoc}`;
export const BusinessCursorFieldsFragmentDoc = gql`
    fragment businessCursorFields on BusinessCursor {
  edges {
    ...businessEdgeFields
  }
  pageInfo {
    hasNextPage
    hasPrevPage
    startCursor
    endCursor
    entries
    pages
  }
}
    ${BusinessEdgeFieldsFragmentDoc}`;
export const BusinessOnboardingFieldsFragmentDoc = gql`
    fragment businessOnboardingFields on BusinessOnboarding {
  id
  name
  category {
    ...businessCategoryFields
  }
  description
  phoneNumber {
    ...phoneNumberFields
  }
  address {
    ...addressFields
  }
  ownerFirstName
  ownerLastName
  ownerIdType
  ownerIdPhotos {
    id
    url
    contentType
  }
  ownerAddress {
    ...addressFields
  }
  bankAccountBank {
    id
    name
  }
  bankAccountHolder
  bankAccountNumber
  socialMedia {
    ...businessSocialMediaFields
  }
}
    ${BusinessCategoryFieldsFragmentDoc}
${PhoneNumberFieldsFragmentDoc}
${AddressFieldsFragmentDoc}
${BusinessSocialMediaFieldsFragmentDoc}`;
export const MoneyFieldsFragmentDoc = gql`
    fragment moneyFields on Money {
  amountInCents
  currencyCode
}
    `;
export const PaymentLinkFieldsFragmentDoc = gql`
    fragment paymentLinkFields on PaymentLink {
  id
  title
  description
  cost {
    ...moneyFields
  }
  active
  reference
  active
  createdAt
  limit
  business {
    ...businessFields
  }
}
    ${MoneyFieldsFragmentDoc}
${BusinessFieldsFragmentDoc}`;
export const CardFLowFieldsFragmentDoc = gql`
    fragment cardFLowFields on CardFlowData {
  actionUrl
  referenceId
  token
}
    `;
export const CardFieldsFragmentDoc = gql`
    fragment cardFields on Card {
  number
  issuer
  flowData {
    ...cardFLowFields
  }
}
    ${CardFLowFieldsFragmentDoc}`;
export const OrderFieldsFragmentDoc = gql`
    fragment orderFields on Order {
  id
  message
  cost {
    ...moneyFields
  }
  reference
  paymentLink {
    ...paymentLinkFields
  }
  phoneNumber {
    ...phoneNumberFields
  }
  firstName
  lastName
  paymentMode
  state
  createdAt
  card {
    ...cardFields
  }
}
    ${MoneyFieldsFragmentDoc}
${PaymentLinkFieldsFragmentDoc}
${PhoneNumberFieldsFragmentDoc}
${CardFieldsFragmentDoc}`;
export const OrderEdgeFieldsFragmentDoc = gql`
    fragment orderEdgeFields on OrderEdge {
  cursor
  node {
    ...orderFields
  }
}
    ${OrderFieldsFragmentDoc}`;
export const OrderCursorFieldsFragmentDoc = gql`
    fragment orderCursorFields on OrderCursor {
  edges {
    ...orderEdgeFields
  }
  pageInfo {
    hasNextPage
    hasPrevPage
    startCursor
    endCursor
    entries
    pages
  }
}
    ${OrderEdgeFieldsFragmentDoc}`;
export const PaymentLinkEdgeFieldsFragmentDoc = gql`
    fragment paymentLinkEdgeFields on PaymentLinkEdge {
  cursor
  node {
    ...paymentLinkFields
  }
}
    ${PaymentLinkFieldsFragmentDoc}`;
export const PaymentLinkCursorFieldsFragmentDoc = gql`
    fragment paymentLinkCursorFields on PaymentLinkCursor {
  edges {
    ...paymentLinkEdgeFields
  }
  pageInfo {
    hasNextPage
    hasPrevPage
    startCursor
    endCursor
    entries
    pages
  }
}
    ${PaymentLinkEdgeFieldsFragmentDoc}`;
export const PayoutFieldsFragmentDoc = gql`
    fragment payoutFields on Payout {
  id
  reference
  status
  mode
  createdAt
  updatedAt
  message
  amount {
    ...moneyFields
  }
  bankAccount {
    ...bankAccountFields
  }
  mobileNumber {
    ...phoneNumberFields
  }
  business {
    ...businessFields
  }
}
    ${MoneyFieldsFragmentDoc}
${BankAccountFieldsFragmentDoc}
${PhoneNumberFieldsFragmentDoc}
${BusinessFieldsFragmentDoc}`;
export const PayoutEdgeFieldsFragmentDoc = gql`
    fragment payoutEdgeFields on PayoutEdge {
  cursor
  node {
    ...payoutFields
  }
}
    ${PayoutFieldsFragmentDoc}`;
export const PayoutConnectionFieldsFragmentDoc = gql`
    fragment payoutConnectionFields on PayoutConnection {
  edges {
    ...payoutEdgeFields
  }
  pageInfo {
    hasNextPage
    hasPrevPage
    startCursor
    endCursor
    entries
    pages
  }
}
    ${PayoutEdgeFieldsFragmentDoc}`;
export const RefundFieldsFragmentDoc = gql`
    fragment refundFields on Refund {
  id
  amount {
    ...moneyFields
  }
  reason
  reference
  order {
    ...orderFields
  }
  status
  createdAt
}
    ${MoneyFieldsFragmentDoc}
${OrderFieldsFragmentDoc}`;
export const RefundEdgeFieldsFragmentDoc = gql`
    fragment refundEdgeFields on RefundEdge {
  cursor
  node {
    ...refundFields
  }
}
    ${RefundFieldsFragmentDoc}`;
export const RefundConnectionFieldsFragmentDoc = gql`
    fragment refundConnectionFields on RefundConnection {
  edges {
    ...refundEdgeFields
  }
  pageInfo {
    hasNextPage
    hasPrevPage
    startCursor
    endCursor
    entries
    pages
  }
}
    ${RefundEdgeFieldsFragmentDoc}`;
export const UserEdgeFieldsFragmentDoc = gql`
    fragment userEdgeFields on UserEdge {
  cursor
  node {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;
export const UserCursorFieldsFragmentDoc = gql`
    fragment userCursorFields on UserCursor {
  edges {
    ...userEdgeFields
  }
  pageInfo {
    hasNextPage
    hasPrevPage
    startCursor
    endCursor
    entries
    pages
  }
}
    ${UserEdgeFieldsFragmentDoc}`;
export const CreateAdminUserDocument = gql`
    mutation CreateAdminUser($input: CreateAdminUserInput!) {
  createAdminUser(input: $input) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;
export type CreateAdminUserMutationFn = Apollo.MutationFunction<CreateAdminUserMutation, CreateAdminUserMutationVariables>;

/**
 * __useCreateAdminUserMutation__
 *
 * To run a mutation, you first call `useCreateAdminUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminUserMutation, { data, loading, error }] = useCreateAdminUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAdminUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdminUserMutation, CreateAdminUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdminUserMutation, CreateAdminUserMutationVariables>(CreateAdminUserDocument, options);
      }
export type CreateAdminUserMutationHookResult = ReturnType<typeof useCreateAdminUserMutation>;
export type CreateAdminUserMutationResult = Apollo.MutationResult<CreateAdminUserMutation>;
export type CreateAdminUserMutationOptions = Apollo.BaseMutationOptions<CreateAdminUserMutation, CreateAdminUserMutationVariables>;
export const RequestLoginOtpDocument = gql`
    mutation RequestLoginOTP($input: LoginInput!) {
  requestLoginOTP(input: $input)
}
    `;
export type RequestLoginOtpMutationFn = Apollo.MutationFunction<RequestLoginOtpMutation, RequestLoginOtpMutationVariables>;

/**
 * __useRequestLoginOtpMutation__
 *
 * To run a mutation, you first call `useRequestLoginOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestLoginOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestLoginOtpMutation, { data, loading, error }] = useRequestLoginOtpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRequestLoginOtpMutation(baseOptions?: Apollo.MutationHookOptions<RequestLoginOtpMutation, RequestLoginOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestLoginOtpMutation, RequestLoginOtpMutationVariables>(RequestLoginOtpDocument, options);
      }
export type RequestLoginOtpMutationHookResult = ReturnType<typeof useRequestLoginOtpMutation>;
export type RequestLoginOtpMutationResult = Apollo.MutationResult<RequestLoginOtpMutation>;
export type RequestLoginOtpMutationOptions = Apollo.BaseMutationOptions<RequestLoginOtpMutation, RequestLoginOtpMutationVariables>;
export const VerifyLoginOtpDocument = gql`
    mutation VerifyLoginOTP($code: String!) {
  verifyLoginOTP(code: $code) {
    accessToken
    refreshToken
    user {
      ...userFields
    }
  }
}
    ${UserFieldsFragmentDoc}`;
export type VerifyLoginOtpMutationFn = Apollo.MutationFunction<VerifyLoginOtpMutation, VerifyLoginOtpMutationVariables>;

/**
 * __useVerifyLoginOtpMutation__
 *
 * To run a mutation, you first call `useVerifyLoginOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyLoginOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyLoginOtpMutation, { data, loading, error }] = useVerifyLoginOtpMutation({
 *   variables: {
 *      code: // value for 'code'
 *   },
 * });
 */
export function useVerifyLoginOtpMutation(baseOptions?: Apollo.MutationHookOptions<VerifyLoginOtpMutation, VerifyLoginOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyLoginOtpMutation, VerifyLoginOtpMutationVariables>(VerifyLoginOtpDocument, options);
      }
export type VerifyLoginOtpMutationHookResult = ReturnType<typeof useVerifyLoginOtpMutation>;
export type VerifyLoginOtpMutationResult = Apollo.MutationResult<VerifyLoginOtpMutation>;
export type VerifyLoginOtpMutationOptions = Apollo.BaseMutationOptions<VerifyLoginOtpMutation, VerifyLoginOtpMutationVariables>;
export const RefreshTokenDocument = gql`
    mutation RefreshToken($input: RefreshTokenInput!) {
  refreshToken(input: $input) {
    accessToken
    refreshToken
  }
}
    `;
export type RefreshTokenMutationFn = Apollo.MutationFunction<RefreshTokenMutation, RefreshTokenMutationVariables>;

/**
 * __useRefreshTokenMutation__
 *
 * To run a mutation, you first call `useRefreshTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshTokenMutation, { data, loading, error }] = useRefreshTokenMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRefreshTokenMutation(baseOptions?: Apollo.MutationHookOptions<RefreshTokenMutation, RefreshTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshTokenMutation, RefreshTokenMutationVariables>(RefreshTokenDocument, options);
      }
export type RefreshTokenMutationHookResult = ReturnType<typeof useRefreshTokenMutation>;
export type RefreshTokenMutationResult = Apollo.MutationResult<RefreshTokenMutation>;
export type RefreshTokenMutationOptions = Apollo.BaseMutationOptions<RefreshTokenMutation, RefreshTokenMutationVariables>;
export const ResendSetAdminPasswordOtpDocument = gql`
    mutation ResendSetAdminPasswordOTP($email: String!) {
  resendSetAdminPasswordOTP(email: $email)
}
    `;
export type ResendSetAdminPasswordOtpMutationFn = Apollo.MutationFunction<ResendSetAdminPasswordOtpMutation, ResendSetAdminPasswordOtpMutationVariables>;

/**
 * __useResendSetAdminPasswordOtpMutation__
 *
 * To run a mutation, you first call `useResendSetAdminPasswordOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendSetAdminPasswordOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendSetAdminPasswordOtpMutation, { data, loading, error }] = useResendSetAdminPasswordOtpMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useResendSetAdminPasswordOtpMutation(baseOptions?: Apollo.MutationHookOptions<ResendSetAdminPasswordOtpMutation, ResendSetAdminPasswordOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendSetAdminPasswordOtpMutation, ResendSetAdminPasswordOtpMutationVariables>(ResendSetAdminPasswordOtpDocument, options);
      }
export type ResendSetAdminPasswordOtpMutationHookResult = ReturnType<typeof useResendSetAdminPasswordOtpMutation>;
export type ResendSetAdminPasswordOtpMutationResult = Apollo.MutationResult<ResendSetAdminPasswordOtpMutation>;
export type ResendSetAdminPasswordOtpMutationOptions = Apollo.BaseMutationOptions<ResendSetAdminPasswordOtpMutation, ResendSetAdminPasswordOtpMutationVariables>;
export const RequestPasswordResetOtpDocument = gql`
    mutation RequestPasswordResetOTP($email: String!) {
  requestPasswordResetOTP(email: $email)
}
    `;
export type RequestPasswordResetOtpMutationFn = Apollo.MutationFunction<RequestPasswordResetOtpMutation, RequestPasswordResetOtpMutationVariables>;

/**
 * __useRequestPasswordResetOtpMutation__
 *
 * To run a mutation, you first call `useRequestPasswordResetOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestPasswordResetOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestPasswordResetOtpMutation, { data, loading, error }] = useRequestPasswordResetOtpMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useRequestPasswordResetOtpMutation(baseOptions?: Apollo.MutationHookOptions<RequestPasswordResetOtpMutation, RequestPasswordResetOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestPasswordResetOtpMutation, RequestPasswordResetOtpMutationVariables>(RequestPasswordResetOtpDocument, options);
      }
export type RequestPasswordResetOtpMutationHookResult = ReturnType<typeof useRequestPasswordResetOtpMutation>;
export type RequestPasswordResetOtpMutationResult = Apollo.MutationResult<RequestPasswordResetOtpMutation>;
export type RequestPasswordResetOtpMutationOptions = Apollo.BaseMutationOptions<RequestPasswordResetOtpMutation, RequestPasswordResetOtpMutationVariables>;
export const SetPasswordDocument = gql`
    mutation SetPassword($input: SetAdminPasswordInput!) {
  setAdminPassword(input: $input)
}
    `;
export type SetPasswordMutationFn = Apollo.MutationFunction<SetPasswordMutation, SetPasswordMutationVariables>;

/**
 * __useSetPasswordMutation__
 *
 * To run a mutation, you first call `useSetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPasswordMutation, { data, loading, error }] = useSetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<SetPasswordMutation, SetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPasswordMutation, SetPasswordMutationVariables>(SetPasswordDocument, options);
      }
export type SetPasswordMutationHookResult = ReturnType<typeof useSetPasswordMutation>;
export type SetPasswordMutationResult = Apollo.MutationResult<SetPasswordMutation>;
export type SetPasswordMutationOptions = Apollo.BaseMutationOptions<SetPasswordMutation, SetPasswordMutationVariables>;
export const SignupDocument = gql`
    mutation Signup($input: SignupInput!) {
  signup(input: $input) {
    firstName
    lastName
    id
    email
    phone {
      number
      countryCode
    }
    createdAt
  }
}
    `;
export type SignupMutationFn = Apollo.MutationFunction<SignupMutation, SignupMutationVariables>;

/**
 * __useSignupMutation__
 *
 * To run a mutation, you first call `useSignupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signupMutation, { data, loading, error }] = useSignupMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignupMutation(baseOptions?: Apollo.MutationHookOptions<SignupMutation, SignupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignupMutation, SignupMutationVariables>(SignupDocument, options);
      }
export type SignupMutationHookResult = ReturnType<typeof useSignupMutation>;
export type SignupMutationResult = Apollo.MutationResult<SignupMutation>;
export type SignupMutationOptions = Apollo.BaseMutationOptions<SignupMutation, SignupMutationVariables>;
export const SubmitBusinessOnboardingDocument = gql`
    mutation SubmitBusinessOnboarding($businessOnboardingId: ID!) {
  submitBusinessOnboarding(businessOnboardingId: $businessOnboardingId)
}
    `;
export type SubmitBusinessOnboardingMutationFn = Apollo.MutationFunction<SubmitBusinessOnboardingMutation, SubmitBusinessOnboardingMutationVariables>;

/**
 * __useSubmitBusinessOnboardingMutation__
 *
 * To run a mutation, you first call `useSubmitBusinessOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitBusinessOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitBusinessOnboardingMutation, { data, loading, error }] = useSubmitBusinessOnboardingMutation({
 *   variables: {
 *      businessOnboardingId: // value for 'businessOnboardingId'
 *   },
 * });
 */
export function useSubmitBusinessOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<SubmitBusinessOnboardingMutation, SubmitBusinessOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitBusinessOnboardingMutation, SubmitBusinessOnboardingMutationVariables>(SubmitBusinessOnboardingDocument, options);
      }
export type SubmitBusinessOnboardingMutationHookResult = ReturnType<typeof useSubmitBusinessOnboardingMutation>;
export type SubmitBusinessOnboardingMutationResult = Apollo.MutationResult<SubmitBusinessOnboardingMutation>;
export type SubmitBusinessOnboardingMutationOptions = Apollo.BaseMutationOptions<SubmitBusinessOnboardingMutation, SubmitBusinessOnboardingMutationVariables>;
export const UpdateBusinessDetailsDocument = gql`
    mutation UpdateBusinessDetails($id: ID!, $input: BusinessOnboardingInput!) {
  updateBusiness(id: $id, input: $input) {
    ...businessFields
  }
}
    ${BusinessFieldsFragmentDoc}`;
export type UpdateBusinessDetailsMutationFn = Apollo.MutationFunction<UpdateBusinessDetailsMutation, UpdateBusinessDetailsMutationVariables>;

/**
 * __useUpdateBusinessDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessDetailsMutation, { data, loading, error }] = useUpdateBusinessDetailsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBusinessDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessDetailsMutation, UpdateBusinessDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBusinessDetailsMutation, UpdateBusinessDetailsMutationVariables>(UpdateBusinessDetailsDocument, options);
      }
export type UpdateBusinessDetailsMutationHookResult = ReturnType<typeof useUpdateBusinessDetailsMutation>;
export type UpdateBusinessDetailsMutationResult = Apollo.MutationResult<UpdateBusinessDetailsMutation>;
export type UpdateBusinessDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessDetailsMutation, UpdateBusinessDetailsMutationVariables>;
export const UpdateBusinessOnboardingDocument = gql`
    mutation UpdateBusinessOnboarding($input: BusinessOnboardingInput!) {
  updateBusinessOnboarding(input: $input) {
    ...businessOnboardingFields
  }
}
    ${BusinessOnboardingFieldsFragmentDoc}`;
export type UpdateBusinessOnboardingMutationFn = Apollo.MutationFunction<UpdateBusinessOnboardingMutation, UpdateBusinessOnboardingMutationVariables>;

/**
 * __useUpdateBusinessOnboardingMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessOnboardingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessOnboardingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessOnboardingMutation, { data, loading, error }] = useUpdateBusinessOnboardingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBusinessOnboardingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessOnboardingMutation, UpdateBusinessOnboardingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBusinessOnboardingMutation, UpdateBusinessOnboardingMutationVariables>(UpdateBusinessOnboardingDocument, options);
      }
export type UpdateBusinessOnboardingMutationHookResult = ReturnType<typeof useUpdateBusinessOnboardingMutation>;
export type UpdateBusinessOnboardingMutationResult = Apollo.MutationResult<UpdateBusinessOnboardingMutation>;
export type UpdateBusinessOnboardingMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessOnboardingMutation, UpdateBusinessOnboardingMutationVariables>;
export const UpdatePasswordDocument = gql`
    mutation UpdatePassword($input: UpdatePasswordInput!) {
  updatePassword(input: $input)
}
    `;
export type UpdatePasswordMutationFn = Apollo.MutationFunction<UpdatePasswordMutation, UpdatePasswordMutationVariables>;

/**
 * __useUpdatePasswordMutation__
 *
 * To run a mutation, you first call `useUpdatePasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePasswordMutation, { data, loading, error }] = useUpdatePasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePasswordMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePasswordMutation, UpdatePasswordMutationVariables>(UpdatePasswordDocument, options);
      }
export type UpdatePasswordMutationHookResult = ReturnType<typeof useUpdatePasswordMutation>;
export type UpdatePasswordMutationResult = Apollo.MutationResult<UpdatePasswordMutation>;
export type UpdatePasswordMutationOptions = Apollo.BaseMutationOptions<UpdatePasswordMutation, UpdatePasswordMutationVariables>;
export const UpdateUserDetailsDocument = gql`
    mutation UpdateUserDetails($input: UpdateUserInput!) {
  updateUser(input: $input) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;
export type UpdateUserDetailsMutationFn = Apollo.MutationFunction<UpdateUserDetailsMutation, UpdateUserDetailsMutationVariables>;

/**
 * __useUpdateUserDetailsMutation__
 *
 * To run a mutation, you first call `useUpdateUserDetailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserDetailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserDetailsMutation, { data, loading, error }] = useUpdateUserDetailsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateUserDetailsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserDetailsMutation, UpdateUserDetailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserDetailsMutation, UpdateUserDetailsMutationVariables>(UpdateUserDetailsDocument, options);
      }
export type UpdateUserDetailsMutationHookResult = ReturnType<typeof useUpdateUserDetailsMutation>;
export type UpdateUserDetailsMutationResult = Apollo.MutationResult<UpdateUserDetailsMutation>;
export type UpdateUserDetailsMutationOptions = Apollo.BaseMutationOptions<UpdateUserDetailsMutation, UpdateUserDetailsMutationVariables>;
export const UploadMediaDocument = gql`
    mutation UploadMedia($file: Upload!) {
  uploadMedia(file: $file) {
    id
  }
}
    `;
export type UploadMediaMutationFn = Apollo.MutationFunction<UploadMediaMutation, UploadMediaMutationVariables>;

/**
 * __useUploadMediaMutation__
 *
 * To run a mutation, you first call `useUploadMediaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadMediaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadMediaMutation, { data, loading, error }] = useUploadMediaMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadMediaMutation(baseOptions?: Apollo.MutationHookOptions<UploadMediaMutation, UploadMediaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadMediaMutation, UploadMediaMutationVariables>(UploadMediaDocument, options);
      }
export type UploadMediaMutationHookResult = ReturnType<typeof useUploadMediaMutation>;
export type UploadMediaMutationResult = Apollo.MutationResult<UploadMediaMutation>;
export type UploadMediaMutationOptions = Apollo.BaseMutationOptions<UploadMediaMutation, UploadMediaMutationVariables>;
export const VerifyAndResetPasswordWithOtpDocument = gql`
    mutation VerifyAndResetPasswordWithOTP($input: ResetPasswordInput!) {
  verifyAndResetPasswordWithOTP(input: $input)
}
    `;
export type VerifyAndResetPasswordWithOtpMutationFn = Apollo.MutationFunction<VerifyAndResetPasswordWithOtpMutation, VerifyAndResetPasswordWithOtpMutationVariables>;

/**
 * __useVerifyAndResetPasswordWithOtpMutation__
 *
 * To run a mutation, you first call `useVerifyAndResetPasswordWithOtpMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAndResetPasswordWithOtpMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAndResetPasswordWithOtpMutation, { data, loading, error }] = useVerifyAndResetPasswordWithOtpMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useVerifyAndResetPasswordWithOtpMutation(baseOptions?: Apollo.MutationHookOptions<VerifyAndResetPasswordWithOtpMutation, VerifyAndResetPasswordWithOtpMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyAndResetPasswordWithOtpMutation, VerifyAndResetPasswordWithOtpMutationVariables>(VerifyAndResetPasswordWithOtpDocument, options);
      }
export type VerifyAndResetPasswordWithOtpMutationHookResult = ReturnType<typeof useVerifyAndResetPasswordWithOtpMutation>;
export type VerifyAndResetPasswordWithOtpMutationResult = Apollo.MutationResult<VerifyAndResetPasswordWithOtpMutation>;
export type VerifyAndResetPasswordWithOtpMutationOptions = Apollo.BaseMutationOptions<VerifyAndResetPasswordWithOtpMutation, VerifyAndResetPasswordWithOtpMutationVariables>;
export const GetActivityLogsDocument = gql`
    query GetActivityLogs($input: ActivityLogInput!) {
  activityLogs(input: $input) {
    ...activityLogCursorFields
  }
}
    ${ActivityLogCursorFieldsFragmentDoc}`;

/**
 * __useGetActivityLogsQuery__
 *
 * To run a query within a React component, call `useGetActivityLogsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityLogsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityLogsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetActivityLogsQuery(baseOptions: Apollo.QueryHookOptions<GetActivityLogsQuery, GetActivityLogsQueryVariables> & ({ variables: GetActivityLogsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityLogsQuery, GetActivityLogsQueryVariables>(GetActivityLogsDocument, options);
      }
export function useGetActivityLogsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityLogsQuery, GetActivityLogsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityLogsQuery, GetActivityLogsQueryVariables>(GetActivityLogsDocument, options);
        }
export function useGetActivityLogsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActivityLogsQuery, GetActivityLogsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActivityLogsQuery, GetActivityLogsQueryVariables>(GetActivityLogsDocument, options);
        }
export type GetActivityLogsQueryHookResult = ReturnType<typeof useGetActivityLogsQuery>;
export type GetActivityLogsLazyQueryHookResult = ReturnType<typeof useGetActivityLogsLazyQuery>;
export type GetActivityLogsSuspenseQueryHookResult = ReturnType<typeof useGetActivityLogsSuspenseQuery>;
export type GetActivityLogsQueryResult = Apollo.QueryResult<GetActivityLogsQuery, GetActivityLogsQueryVariables>;
export const GetActivityLogDocument = gql`
    query GetActivityLog($id: ID!) {
  activityLog(id: $id) {
    ...activityLogFields
  }
}
    ${ActivityLogFieldsFragmentDoc}`;

/**
 * __useGetActivityLogQuery__
 *
 * To run a query within a React component, call `useGetActivityLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityLogQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetActivityLogQuery(baseOptions: Apollo.QueryHookOptions<GetActivityLogQuery, GetActivityLogQueryVariables> & ({ variables: GetActivityLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityLogQuery, GetActivityLogQueryVariables>(GetActivityLogDocument, options);
      }
export function useGetActivityLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityLogQuery, GetActivityLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityLogQuery, GetActivityLogQueryVariables>(GetActivityLogDocument, options);
        }
export function useGetActivityLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetActivityLogQuery, GetActivityLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetActivityLogQuery, GetActivityLogQueryVariables>(GetActivityLogDocument, options);
        }
export type GetActivityLogQueryHookResult = ReturnType<typeof useGetActivityLogQuery>;
export type GetActivityLogLazyQueryHookResult = ReturnType<typeof useGetActivityLogLazyQuery>;
export type GetActivityLogSuspenseQueryHookResult = ReturnType<typeof useGetActivityLogSuspenseQuery>;
export type GetActivityLogQueryResult = Apollo.QueryResult<GetActivityLogQuery, GetActivityLogQueryVariables>;
export const GetBanksDocument = gql`
    query GetBanks {
  banks {
    ...banksFields
  }
}
    ${BanksFieldsFragmentDoc}`;

/**
 * __useGetBanksQuery__
 *
 * To run a query within a React component, call `useGetBanksQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBanksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBanksQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBanksQuery(baseOptions?: Apollo.QueryHookOptions<GetBanksQuery, GetBanksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBanksQuery, GetBanksQueryVariables>(GetBanksDocument, options);
      }
export function useGetBanksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBanksQuery, GetBanksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBanksQuery, GetBanksQueryVariables>(GetBanksDocument, options);
        }
export function useGetBanksSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBanksQuery, GetBanksQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBanksQuery, GetBanksQueryVariables>(GetBanksDocument, options);
        }
export type GetBanksQueryHookResult = ReturnType<typeof useGetBanksQuery>;
export type GetBanksLazyQueryHookResult = ReturnType<typeof useGetBanksLazyQuery>;
export type GetBanksSuspenseQueryHookResult = ReturnType<typeof useGetBanksSuspenseQuery>;
export type GetBanksQueryResult = Apollo.QueryResult<GetBanksQuery, GetBanksQueryVariables>;
export const GetBusinessDocument = gql`
    query GetBusiness($id: ID, $currency: [CurrencyCode!]) {
  business(id: $id) {
    ...businessFieldsWithFeeProfiles
    balance(currency: $currency) {
      ...businessBalanceFields
    }
  }
}
    ${BusinessFieldsWithFeeProfilesFragmentDoc}
${BusinessBalanceFieldsFragmentDoc}`;

/**
 * __useGetBusinessQuery__
 *
 * To run a query within a React component, call `useGetBusinessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessQuery({
 *   variables: {
 *      id: // value for 'id'
 *      currency: // value for 'currency'
 *   },
 * });
 */
export function useGetBusinessQuery(baseOptions?: Apollo.QueryHookOptions<GetBusinessQuery, GetBusinessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessQuery, GetBusinessQueryVariables>(GetBusinessDocument, options);
      }
export function useGetBusinessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessQuery, GetBusinessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessQuery, GetBusinessQueryVariables>(GetBusinessDocument, options);
        }
export function useGetBusinessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBusinessQuery, GetBusinessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBusinessQuery, GetBusinessQueryVariables>(GetBusinessDocument, options);
        }
export type GetBusinessQueryHookResult = ReturnType<typeof useGetBusinessQuery>;
export type GetBusinessLazyQueryHookResult = ReturnType<typeof useGetBusinessLazyQuery>;
export type GetBusinessSuspenseQueryHookResult = ReturnType<typeof useGetBusinessSuspenseQuery>;
export type GetBusinessQueryResult = Apollo.QueryResult<GetBusinessQuery, GetBusinessQueryVariables>;
export const GetBusinessCategoriesDocument = gql`
    query GetBusinessCategories {
  businessCategories {
    ...businessCategoryFields
  }
}
    ${BusinessCategoryFieldsFragmentDoc}`;

/**
 * __useGetBusinessCategoriesQuery__
 *
 * To run a query within a React component, call `useGetBusinessCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBusinessCategoriesQuery(baseOptions?: Apollo.QueryHookOptions<GetBusinessCategoriesQuery, GetBusinessCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessCategoriesQuery, GetBusinessCategoriesQueryVariables>(GetBusinessCategoriesDocument, options);
      }
export function useGetBusinessCategoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessCategoriesQuery, GetBusinessCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessCategoriesQuery, GetBusinessCategoriesQueryVariables>(GetBusinessCategoriesDocument, options);
        }
export function useGetBusinessCategoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBusinessCategoriesQuery, GetBusinessCategoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBusinessCategoriesQuery, GetBusinessCategoriesQueryVariables>(GetBusinessCategoriesDocument, options);
        }
export type GetBusinessCategoriesQueryHookResult = ReturnType<typeof useGetBusinessCategoriesQuery>;
export type GetBusinessCategoriesLazyQueryHookResult = ReturnType<typeof useGetBusinessCategoriesLazyQuery>;
export type GetBusinessCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetBusinessCategoriesSuspenseQuery>;
export type GetBusinessCategoriesQueryResult = Apollo.QueryResult<GetBusinessCategoriesQuery, GetBusinessCategoriesQueryVariables>;
export const GetBusinessesDocument = gql`
    query GetBusinesses($input: BusinessesInput!) {
  businesses(input: $input) {
    ...businessCursorFields
  }
}
    ${BusinessCursorFieldsFragmentDoc}`;

/**
 * __useGetBusinessesQuery__
 *
 * To run a query within a React component, call `useGetBusinessesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetBusinessesQuery(baseOptions: Apollo.QueryHookOptions<GetBusinessesQuery, GetBusinessesQueryVariables> & ({ variables: GetBusinessesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessesQuery, GetBusinessesQueryVariables>(GetBusinessesDocument, options);
      }
export function useGetBusinessesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessesQuery, GetBusinessesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessesQuery, GetBusinessesQueryVariables>(GetBusinessesDocument, options);
        }
export function useGetBusinessesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBusinessesQuery, GetBusinessesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBusinessesQuery, GetBusinessesQueryVariables>(GetBusinessesDocument, options);
        }
export type GetBusinessesQueryHookResult = ReturnType<typeof useGetBusinessesQuery>;
export type GetBusinessesLazyQueryHookResult = ReturnType<typeof useGetBusinessesLazyQuery>;
export type GetBusinessesSuspenseQueryHookResult = ReturnType<typeof useGetBusinessesSuspenseQuery>;
export type GetBusinessesQueryResult = Apollo.QueryResult<GetBusinessesQuery, GetBusinessesQueryVariables>;
export const GetFeeProfilesDocument = gql`
    query GetFeeProfiles {
  feeProfiles {
    id
    name
    code
  }
}
    `;

/**
 * __useGetFeeProfilesQuery__
 *
 * To run a query within a React component, call `useGetFeeProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeeProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeeProfilesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeeProfilesQuery(baseOptions?: Apollo.QueryHookOptions<GetFeeProfilesQuery, GetFeeProfilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeeProfilesQuery, GetFeeProfilesQueryVariables>(GetFeeProfilesDocument, options);
      }
export function useGetFeeProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeeProfilesQuery, GetFeeProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeeProfilesQuery, GetFeeProfilesQueryVariables>(GetFeeProfilesDocument, options);
        }
export function useGetFeeProfilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFeeProfilesQuery, GetFeeProfilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeeProfilesQuery, GetFeeProfilesQueryVariables>(GetFeeProfilesDocument, options);
        }
export type GetFeeProfilesQueryHookResult = ReturnType<typeof useGetFeeProfilesQuery>;
export type GetFeeProfilesLazyQueryHookResult = ReturnType<typeof useGetFeeProfilesLazyQuery>;
export type GetFeeProfilesSuspenseQueryHookResult = ReturnType<typeof useGetFeeProfilesSuspenseQuery>;
export type GetFeeProfilesQueryResult = Apollo.QueryResult<GetFeeProfilesQuery, GetFeeProfilesQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export function useMeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeSuspenseQueryHookResult = ReturnType<typeof useMeSuspenseQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const GetOrderDocument = gql`
    query GetOrder($id: ID, $reference: String) {
  order(id: $id, reference: $reference) {
    ...orderFields
  }
}
    ${OrderFieldsFragmentDoc}`;

/**
 * __useGetOrderQuery__
 *
 * To run a query within a React component, call `useGetOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrderQuery({
 *   variables: {
 *      id: // value for 'id'
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useGetOrderQuery(baseOptions?: Apollo.QueryHookOptions<GetOrderQuery, GetOrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, options);
      }
export function useGetOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrderQuery, GetOrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, options);
        }
export function useGetOrderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrderQuery, GetOrderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrderQuery, GetOrderQueryVariables>(GetOrderDocument, options);
        }
export type GetOrderQueryHookResult = ReturnType<typeof useGetOrderQuery>;
export type GetOrderLazyQueryHookResult = ReturnType<typeof useGetOrderLazyQuery>;
export type GetOrderSuspenseQueryHookResult = ReturnType<typeof useGetOrderSuspenseQuery>;
export type GetOrderQueryResult = Apollo.QueryResult<GetOrderQuery, GetOrderQueryVariables>;
export const GetOrdersDocument = gql`
    query GetOrders($input: OrderCursorInput!) {
  orders(input: $input) {
    ...orderCursorFields
  }
}
    ${OrderCursorFieldsFragmentDoc}`;

/**
 * __useGetOrdersQuery__
 *
 * To run a query within a React component, call `useGetOrdersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrdersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrdersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetOrdersQuery(baseOptions: Apollo.QueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables> & ({ variables: GetOrdersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrdersQuery, GetOrdersQueryVariables>(GetOrdersDocument, options);
      }
export function useGetOrdersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrdersQuery, GetOrdersQueryVariables>(GetOrdersDocument, options);
        }
export function useGetOrdersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrdersQuery, GetOrdersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrdersQuery, GetOrdersQueryVariables>(GetOrdersDocument, options);
        }
export type GetOrdersQueryHookResult = ReturnType<typeof useGetOrdersQuery>;
export type GetOrdersLazyQueryHookResult = ReturnType<typeof useGetOrdersLazyQuery>;
export type GetOrdersSuspenseQueryHookResult = ReturnType<typeof useGetOrdersSuspenseQuery>;
export type GetOrdersQueryResult = Apollo.QueryResult<GetOrdersQuery, GetOrdersQueryVariables>;
export const GetPayoutDocument = gql`
    query GetPayout($id: ID!) {
  payout(id: $id) {
    ...payoutFields
  }
}
    ${PayoutFieldsFragmentDoc}`;

/**
 * __useGetPayoutQuery__
 *
 * To run a query within a React component, call `useGetPayoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayoutQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPayoutQuery(baseOptions: Apollo.QueryHookOptions<GetPayoutQuery, GetPayoutQueryVariables> & ({ variables: GetPayoutQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPayoutQuery, GetPayoutQueryVariables>(GetPayoutDocument, options);
      }
export function useGetPayoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPayoutQuery, GetPayoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPayoutQuery, GetPayoutQueryVariables>(GetPayoutDocument, options);
        }
export function useGetPayoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPayoutQuery, GetPayoutQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPayoutQuery, GetPayoutQueryVariables>(GetPayoutDocument, options);
        }
export type GetPayoutQueryHookResult = ReturnType<typeof useGetPayoutQuery>;
export type GetPayoutLazyQueryHookResult = ReturnType<typeof useGetPayoutLazyQuery>;
export type GetPayoutSuspenseQueryHookResult = ReturnType<typeof useGetPayoutSuspenseQuery>;
export type GetPayoutQueryResult = Apollo.QueryResult<GetPayoutQuery, GetPayoutQueryVariables>;
export const GetPayoutsDocument = gql`
    query GetPayouts($input: PayoutInput!) {
  payouts(input: $input) {
    ...payoutConnectionFields
  }
}
    ${PayoutConnectionFieldsFragmentDoc}`;

/**
 * __useGetPayoutsQuery__
 *
 * To run a query within a React component, call `useGetPayoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPayoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPayoutsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetPayoutsQuery(baseOptions: Apollo.QueryHookOptions<GetPayoutsQuery, GetPayoutsQueryVariables> & ({ variables: GetPayoutsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPayoutsQuery, GetPayoutsQueryVariables>(GetPayoutsDocument, options);
      }
export function useGetPayoutsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPayoutsQuery, GetPayoutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPayoutsQuery, GetPayoutsQueryVariables>(GetPayoutsDocument, options);
        }
export function useGetPayoutsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPayoutsQuery, GetPayoutsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPayoutsQuery, GetPayoutsQueryVariables>(GetPayoutsDocument, options);
        }
export type GetPayoutsQueryHookResult = ReturnType<typeof useGetPayoutsQuery>;
export type GetPayoutsLazyQueryHookResult = ReturnType<typeof useGetPayoutsLazyQuery>;
export type GetPayoutsSuspenseQueryHookResult = ReturnType<typeof useGetPayoutsSuspenseQuery>;
export type GetPayoutsQueryResult = Apollo.QueryResult<GetPayoutsQuery, GetPayoutsQueryVariables>;
export const GetRefundDocument = gql`
    query GetRefund($id: ID, $reference: String) {
  refund(id: $id, reference: $reference) {
    ...refundFields
  }
}
    ${RefundFieldsFragmentDoc}`;

/**
 * __useGetRefundQuery__
 *
 * To run a query within a React component, call `useGetRefundQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRefundQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRefundQuery({
 *   variables: {
 *      id: // value for 'id'
 *      reference: // value for 'reference'
 *   },
 * });
 */
export function useGetRefundQuery(baseOptions?: Apollo.QueryHookOptions<GetRefundQuery, GetRefundQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRefundQuery, GetRefundQueryVariables>(GetRefundDocument, options);
      }
export function useGetRefundLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRefundQuery, GetRefundQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRefundQuery, GetRefundQueryVariables>(GetRefundDocument, options);
        }
export function useGetRefundSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRefundQuery, GetRefundQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRefundQuery, GetRefundQueryVariables>(GetRefundDocument, options);
        }
export type GetRefundQueryHookResult = ReturnType<typeof useGetRefundQuery>;
export type GetRefundLazyQueryHookResult = ReturnType<typeof useGetRefundLazyQuery>;
export type GetRefundSuspenseQueryHookResult = ReturnType<typeof useGetRefundSuspenseQuery>;
export type GetRefundQueryResult = Apollo.QueryResult<GetRefundQuery, GetRefundQueryVariables>;
export const GetRefundsDocument = gql`
    query GetRefunds($input: RefundInput!) {
  refunds(input: $input) {
    ...refundConnectionFields
  }
}
    ${RefundConnectionFieldsFragmentDoc}`;

/**
 * __useGetRefundsQuery__
 *
 * To run a query within a React component, call `useGetRefundsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRefundsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRefundsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetRefundsQuery(baseOptions: Apollo.QueryHookOptions<GetRefundsQuery, GetRefundsQueryVariables> & ({ variables: GetRefundsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRefundsQuery, GetRefundsQueryVariables>(GetRefundsDocument, options);
      }
export function useGetRefundsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRefundsQuery, GetRefundsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRefundsQuery, GetRefundsQueryVariables>(GetRefundsDocument, options);
        }
export function useGetRefundsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetRefundsQuery, GetRefundsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetRefundsQuery, GetRefundsQueryVariables>(GetRefundsDocument, options);
        }
export type GetRefundsQueryHookResult = ReturnType<typeof useGetRefundsQuery>;
export type GetRefundsLazyQueryHookResult = ReturnType<typeof useGetRefundsLazyQuery>;
export type GetRefundsSuspenseQueryHookResult = ReturnType<typeof useGetRefundsSuspenseQuery>;
export type GetRefundsQueryResult = Apollo.QueryResult<GetRefundsQuery, GetRefundsQueryVariables>;
export const TransactionDocument = gql`
    query Transaction($id: ID!) {
  transaction(id: $id) {
    id
    status
    amount {
      amountInCents
      currencyCode
    }
    message
    createdAt
    business {
      id
      name
    }
    paymentProvider
    transactionCard {
      number
      issuer
      cardSource
      settlementInfo {
        amount {
          amountInCents
          currencyCode
        }
        settled
        date
      }
    }
    transactionMpesa {
      phoneNumber
    }
    fee {
      amountInCents
      currencyCode
    }
  }
}
    `;

/**
 * __useTransactionQuery__
 *
 * To run a query within a React component, call `useTransactionQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTransactionQuery(baseOptions: Apollo.QueryHookOptions<TransactionQuery, TransactionQueryVariables> & ({ variables: TransactionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionQuery, TransactionQueryVariables>(TransactionDocument, options);
      }
export function useTransactionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionQuery, TransactionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionQuery, TransactionQueryVariables>(TransactionDocument, options);
        }
export function useTransactionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransactionQuery, TransactionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransactionQuery, TransactionQueryVariables>(TransactionDocument, options);
        }
export type TransactionQueryHookResult = ReturnType<typeof useTransactionQuery>;
export type TransactionLazyQueryHookResult = ReturnType<typeof useTransactionLazyQuery>;
export type TransactionSuspenseQueryHookResult = ReturnType<typeof useTransactionSuspenseQuery>;
export type TransactionQueryResult = Apollo.QueryResult<TransactionQuery, TransactionQueryVariables>;
export const TransactionsDocument = gql`
    query Transactions($input: TransactionInput!) {
  transactions(input: $input) {
    edges {
      node {
        id
        createdAt
        paymentProvider
        status
        business {
          id
          name
        }
        transactionCard {
          issuer
        }
        amount {
          ...moneyFields
        }
      }
    }
    pageInfo {
      hasNextPage
      hasPrevPage
      startCursor
      endCursor
      entries
      pages
    }
  }
}
    ${MoneyFieldsFragmentDoc}`;

/**
 * __useTransactionsQuery__
 *
 * To run a query within a React component, call `useTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTransactionsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTransactionsQuery(baseOptions: Apollo.QueryHookOptions<TransactionsQuery, TransactionsQueryVariables> & ({ variables: TransactionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TransactionsQuery, TransactionsQueryVariables>(TransactionsDocument, options);
      }
export function useTransactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TransactionsQuery, TransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TransactionsQuery, TransactionsQueryVariables>(TransactionsDocument, options);
        }
export function useTransactionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TransactionsQuery, TransactionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TransactionsQuery, TransactionsQueryVariables>(TransactionsDocument, options);
        }
export type TransactionsQueryHookResult = ReturnType<typeof useTransactionsQuery>;
export type TransactionsLazyQueryHookResult = ReturnType<typeof useTransactionsLazyQuery>;
export type TransactionsSuspenseQueryHookResult = ReturnType<typeof useTransactionsSuspenseQuery>;
export type TransactionsQueryResult = Apollo.QueryResult<TransactionsQuery, TransactionsQueryVariables>;
export const GetUserDocument = gql`
    query GetUser($id: ID!) {
  user(id: $id) {
    ...userFields
  }
}
    ${UserFieldsFragmentDoc}`;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables> & ({ variables: GetUserQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export function useGetUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserSuspenseQueryHookResult = ReturnType<typeof useGetUserSuspenseQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetUsersDocument = gql`
    query GetUsers($input: UsersInput!) {
  users(input: $input) {
    ...userCursorFields
  }
}
    ${UserCursorFieldsFragmentDoc}`;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables> & ({ variables: GetUsersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export function useGetUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersSuspenseQueryHookResult = ReturnType<typeof useGetUsersSuspenseQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export type WithIndex<TObject> = TObject & Record<string, any>;
export type ResolversObject<TObject> = WithIndex<TObject>;

export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

/** Mapping of union types */
export type ResolversUnionTypes<_RefType extends Record<string, unknown>> = ResolversObject<{
  TargetEntityUnion: ( Business ) | ( BusinessCategory ) | ( Order ) | ( PaymentLink ) | ( Payout ) | ( User );
}>;

/** Mapping of interface types */
export type ResolversInterfaceTypes<_RefType extends Record<string, unknown>> = ResolversObject<{
  Error: ( ValidationError );
}>;

/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = ResolversObject<{
  ActivityLog: ResolverTypeWrapper<Omit<ActivityLog, 'target'> & { target?: Maybe<ResolversTypes['TargetEntityUnion']> }>;
  ActivityLogCursor: ResolverTypeWrapper<Omit<ActivityLogCursor, 'edges'> & { edges: Array<ResolversTypes['ActivityLogEdge']> }>;
  ActivityLogEdge: ResolverTypeWrapper<Omit<ActivityLogEdge, 'node'> & { node: ResolversTypes['ActivityLog'] }>;
  ActivityLogFilter: ActivityLogFilter;
  ActivityLogInput: ActivityLogInput;
  ActivityType: ActivityType;
  ActorType: ActorType;
  Address: ResolverTypeWrapper<Address>;
  AddressInput: AddressInput;
  AmountComparisonOperator: AmountComparisonOperator;
  AmountFilterInput: AmountFilterInput;
  Application: Application;
  Bank: ResolverTypeWrapper<Bank>;
  BankAccount: ResolverTypeWrapper<BankAccount>;
  BetweenAmountInput: BetweenAmountInput;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  Business: ResolverTypeWrapper<Business>;
  BusinessBalance: ResolverTypeWrapper<BusinessBalance>;
  BusinessCategory: ResolverTypeWrapper<BusinessCategory>;
  BusinessCursor: ResolverTypeWrapper<BusinessCursor>;
  BusinessEdge: ResolverTypeWrapper<BusinessEdge>;
  BusinessOnboarding: ResolverTypeWrapper<BusinessOnboarding>;
  BusinessOnboardingBankAccountInput: BusinessOnboardingBankAccountInput;
  BusinessOnboardingInput: BusinessOnboardingInput;
  BusinessOnboardingOwnerInput: BusinessOnboardingOwnerInput;
  BusinessOnboardingSocialMediaInput: BusinessOnboardingSocialMediaInput;
  BusinessOwner: ResolverTypeWrapper<BusinessOwner>;
  BusinessSocialMedia: ResolverTypeWrapper<BusinessSocialMedia>;
  BusinessesInput: BusinessesInput;
  Card: ResolverTypeWrapper<Card>;
  CardFlowData: ResolverTypeWrapper<CardFlowData>;
  CardFlowDataInput: CardFlowDataInput;
  CardInput: CardInput;
  CardIssuer: CardIssuer;
  CardSource: CardSource;
  ComplianceStatus: ComplianceStatus;
  CreateAdminUserInput: CreateAdminUserInput;
  CreateRefundInput: CreateRefundInput;
  CurrencyCode: CurrencyCode;
  CursorInput: CursorInput;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']['output']>;
  DateTimeFilter: DateTimeFilter;
  Entity: Entity;
  Error: ResolverTypeWrapper<ResolversInterfaceTypes<ResolversTypes>['Error']>;
  ErrorTypes: ErrorTypes;
  FeeProfile: ResolverTypeWrapper<FeeProfile>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  GeoCoordinates: ResolverTypeWrapper<GeoCoordinates>;
  GeoCoordinatesInput: GeoCoordinatesInput;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  Image: ResolverTypeWrapper<Image>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  JSON: ResolverTypeWrapper<Scalars['JSON']['output']>;
  Location: ResolverTypeWrapper<Location>;
  Login: ResolverTypeWrapper<Login>;
  LoginInput: LoginInput;
  LogoutInput: LogoutInput;
  Media: ResolverTypeWrapper<Media>;
  Money: ResolverTypeWrapper<Money>;
  MoneyInput: MoneyInput;
  Order: ResolverTypeWrapper<Order>;
  OrderCursor: ResolverTypeWrapper<OrderCursor>;
  OrderCursorInput: OrderCursorInput;
  OrderEdge: ResolverTypeWrapper<OrderEdge>;
  OrderFilter: OrderFilter;
  OrderInput: OrderInput;
  OrderPaymentMode: OrderPaymentMode;
  OrderState: OrderState;
  PageInfo: ResolverTypeWrapper<PageInfo>;
  PaymentLink: ResolverTypeWrapper<PaymentLink>;
  PaymentLinkCursor: ResolverTypeWrapper<PaymentLinkCursor>;
  PaymentLinkCursorInput: PaymentLinkCursorInput;
  PaymentLinkEdge: ResolverTypeWrapper<PaymentLinkEdge>;
  PaymentLinkInput: PaymentLinkInput;
  PaymentProvider: PaymentProvider;
  Payout: ResolverTypeWrapper<Payout>;
  PayoutConnection: ResolverTypeWrapper<PayoutConnection>;
  PayoutEdge: ResolverTypeWrapper<PayoutEdge>;
  PayoutFilterInput: PayoutFilterInput;
  PayoutInput: PayoutInput;
  PayoutMode: PayoutMode;
  PayoutStatus: PayoutStatus;
  PhoneNumber: ResolverTypeWrapper<PhoneNumber>;
  PhoneNumberInput: PhoneNumberInput;
  RefreshTokenInput: RefreshTokenInput;
  Refund: ResolverTypeWrapper<Refund>;
  RefundConnection: ResolverTypeWrapper<RefundConnection>;
  RefundEdge: ResolverTypeWrapper<RefundEdge>;
  RefundFilterInput: RefundFilterInput;
  RefundInput: RefundInput;
  RefundStatus: RefundStatus;
  RequestPayoutInput: RequestPayoutInput;
  ResetPasswordInput: ResetPasswordInput;
  RootMutationType: ResolverTypeWrapper<{}>;
  RootQueryType: ResolverTypeWrapper<{}>;
  RootSubscriptionType: ResolverTypeWrapper<{}>;
  SetAdminPasswordInput: SetAdminPasswordInput;
  SettlementInfo: ResolverTypeWrapper<SettlementInfo>;
  SignupInput: SignupInput;
  SingleEntityFilter: SingleEntityFilter;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  TargetEntityUnion: ResolverTypeWrapper<ResolversUnionTypes<ResolversTypes>['TargetEntityUnion']>;
  TimeInHm: ResolverTypeWrapper<Scalars['TimeInHm']['output']>;
  Transaction: ResolverTypeWrapper<Transaction>;
  TransactionCard: ResolverTypeWrapper<TransactionCard>;
  TransactionCursor: ResolverTypeWrapper<TransactionCursor>;
  TransactionEdge: ResolverTypeWrapper<TransactionEdge>;
  TransactionFilterInput: TransactionFilterInput;
  TransactionInput: TransactionInput;
  TransactionMpesa: ResolverTypeWrapper<TransactionMpesa>;
  TransactionStatus: TransactionStatus;
  UpdatePasswordInput: UpdatePasswordInput;
  UpdatePaymentLinkInput: UpdatePaymentLinkInput;
  UpdateUserInput: UpdateUserInput;
  Upload: ResolverTypeWrapper<Scalars['Upload']['output']>;
  User: ResolverTypeWrapper<User>;
  UserCursor: ResolverTypeWrapper<UserCursor>;
  UserEdge: ResolverTypeWrapper<UserEdge>;
  UserRole: UserRole;
  UserStatus: UserStatus;
  UsersInput: UsersInput;
  ValidationError: ResolverTypeWrapper<ValidationError>;
  VerificationCode: ResolverTypeWrapper<VerificationCode>;
  VerificationCodeStatus: VerificationCodeStatus;
  VerificationIdType: VerificationIdType;
  VerifyCodeInput: VerifyCodeInput;
}>;

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = ResolversObject<{
  ActivityLog: Omit<ActivityLog, 'target'> & { target?: Maybe<ResolversParentTypes['TargetEntityUnion']> };
  ActivityLogCursor: Omit<ActivityLogCursor, 'edges'> & { edges: Array<ResolversParentTypes['ActivityLogEdge']> };
  ActivityLogEdge: Omit<ActivityLogEdge, 'node'> & { node: ResolversParentTypes['ActivityLog'] };
  ActivityLogFilter: ActivityLogFilter;
  ActivityLogInput: ActivityLogInput;
  Address: Address;
  AddressInput: AddressInput;
  AmountFilterInput: AmountFilterInput;
  Bank: Bank;
  BankAccount: BankAccount;
  BetweenAmountInput: BetweenAmountInput;
  Boolean: Scalars['Boolean']['output'];
  Business: Business;
  BusinessBalance: BusinessBalance;
  BusinessCategory: BusinessCategory;
  BusinessCursor: BusinessCursor;
  BusinessEdge: BusinessEdge;
  BusinessOnboarding: BusinessOnboarding;
  BusinessOnboardingBankAccountInput: BusinessOnboardingBankAccountInput;
  BusinessOnboardingInput: BusinessOnboardingInput;
  BusinessOnboardingOwnerInput: BusinessOnboardingOwnerInput;
  BusinessOnboardingSocialMediaInput: BusinessOnboardingSocialMediaInput;
  BusinessOwner: BusinessOwner;
  BusinessSocialMedia: BusinessSocialMedia;
  BusinessesInput: BusinessesInput;
  Card: Card;
  CardFlowData: CardFlowData;
  CardFlowDataInput: CardFlowDataInput;
  CardInput: CardInput;
  CreateAdminUserInput: CreateAdminUserInput;
  CreateRefundInput: CreateRefundInput;
  CursorInput: CursorInput;
  DateTime: Scalars['DateTime']['output'];
  DateTimeFilter: DateTimeFilter;
  Error: ResolversInterfaceTypes<ResolversParentTypes>['Error'];
  FeeProfile: FeeProfile;
  Float: Scalars['Float']['output'];
  GeoCoordinates: GeoCoordinates;
  GeoCoordinatesInput: GeoCoordinatesInput;
  ID: Scalars['ID']['output'];
  Image: Image;
  Int: Scalars['Int']['output'];
  JSON: Scalars['JSON']['output'];
  Location: Location;
  Login: Login;
  LoginInput: LoginInput;
  LogoutInput: LogoutInput;
  Media: Media;
  Money: Money;
  MoneyInput: MoneyInput;
  Order: Order;
  OrderCursor: OrderCursor;
  OrderCursorInput: OrderCursorInput;
  OrderEdge: OrderEdge;
  OrderFilter: OrderFilter;
  OrderInput: OrderInput;
  PageInfo: PageInfo;
  PaymentLink: PaymentLink;
  PaymentLinkCursor: PaymentLinkCursor;
  PaymentLinkCursorInput: PaymentLinkCursorInput;
  PaymentLinkEdge: PaymentLinkEdge;
  PaymentLinkInput: PaymentLinkInput;
  Payout: Payout;
  PayoutConnection: PayoutConnection;
  PayoutEdge: PayoutEdge;
  PayoutFilterInput: PayoutFilterInput;
  PayoutInput: PayoutInput;
  PhoneNumber: PhoneNumber;
  PhoneNumberInput: PhoneNumberInput;
  RefreshTokenInput: RefreshTokenInput;
  Refund: Refund;
  RefundConnection: RefundConnection;
  RefundEdge: RefundEdge;
  RefundFilterInput: RefundFilterInput;
  RefundInput: RefundInput;
  RequestPayoutInput: RequestPayoutInput;
  ResetPasswordInput: ResetPasswordInput;
  RootMutationType: {};
  RootQueryType: {};
  RootSubscriptionType: {};
  SetAdminPasswordInput: SetAdminPasswordInput;
  SettlementInfo: SettlementInfo;
  SignupInput: SignupInput;
  SingleEntityFilter: SingleEntityFilter;
  String: Scalars['String']['output'];
  TargetEntityUnion: ResolversUnionTypes<ResolversParentTypes>['TargetEntityUnion'];
  TimeInHm: Scalars['TimeInHm']['output'];
  Transaction: Transaction;
  TransactionCard: TransactionCard;
  TransactionCursor: TransactionCursor;
  TransactionEdge: TransactionEdge;
  TransactionFilterInput: TransactionFilterInput;
  TransactionInput: TransactionInput;
  TransactionMpesa: TransactionMpesa;
  UpdatePasswordInput: UpdatePasswordInput;
  UpdatePaymentLinkInput: UpdatePaymentLinkInput;
  UpdateUserInput: UpdateUserInput;
  Upload: Scalars['Upload']['output'];
  User: User;
  UserCursor: UserCursor;
  UserEdge: UserEdge;
  UsersInput: UsersInput;
  ValidationError: ValidationError;
  VerificationCode: VerificationCode;
  VerifyCodeInput: VerifyCodeInput;
}>;

export type AuthenticatedDirectiveArgs = {
  roles?: Maybe<Array<UserRole>>;
};

export type AuthenticatedDirectiveResolver<Result, Parent, ContextType = any, Args = AuthenticatedDirectiveArgs> = DirectiveResolverFn<Result, Parent, ContextType, Args>;

export type ActivityLogResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityLog'] = ResolversParentTypes['ActivityLog']> = ResolversObject<{
  activityType?: Resolver<ResolversTypes['ActivityType'], ParentType, ContextType>;
  actorType?: Resolver<ResolversTypes['ActorType'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  metadata?: Resolver<Maybe<ResolversTypes['JSON']>, ParentType, ContextType>;
  performedBy?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  target?: Resolver<Maybe<ResolversTypes['TargetEntityUnion']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ActivityLogCursorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityLogCursor'] = ResolversParentTypes['ActivityLogCursor']> = ResolversObject<{
  edges?: Resolver<Array<ResolversTypes['ActivityLogEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ActivityLogEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['ActivityLogEdge'] = ResolversParentTypes['ActivityLogEdge']> = ResolversObject<{
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['ActivityLog'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type AddressResolvers<ContextType = any, ParentType extends ResolversParentTypes['Address'] = ResolversParentTypes['Address']> = ResolversObject<{
  buildingName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  location?: Resolver<ResolversTypes['Location'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BankResolvers<ContextType = any, ParentType extends ResolversParentTypes['Bank'] = ResolversParentTypes['Bank']> = ResolversObject<{
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BankAccountResolvers<ContextType = any, ParentType extends ResolversParentTypes['BankAccount'] = ResolversParentTypes['BankAccount']> = ResolversObject<{
  accountHolder?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  accountNumber?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  bank?: Resolver<ResolversTypes['Bank'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BusinessResolvers<ContextType = any, ParentType extends ResolversParentTypes['Business'] = ResolversParentTypes['Business']> = ResolversObject<{
  address?: Resolver<ResolversTypes['Address'], ParentType, ContextType>;
  balance?: Resolver<Array<ResolversTypes['BusinessBalance']>, ParentType, ContextType, Partial<BusinessBalanceArgs>>;
  bankAccount?: Resolver<ResolversTypes['BankAccount'], ParentType, ContextType>;
  category?: Resolver<ResolversTypes['BusinessCategory'], ParentType, ContextType>;
  complianceStatus?: Resolver<ResolversTypes['ComplianceStatus'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  feeProfile?: Resolver<Maybe<ResolversTypes['FeeProfile']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  members?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  owner?: Resolver<ResolversTypes['BusinessOwner'], ParentType, ContextType>;
  phoneNumber?: Resolver<ResolversTypes['PhoneNumber'], ParentType, ContextType>;
  socialMedia?: Resolver<ResolversTypes['BusinessSocialMedia'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BusinessBalanceResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessBalance'] = ResolversParentTypes['BusinessBalance']> = ResolversObject<{
  available?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  blocked?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  currency?: Resolver<ResolversTypes['CurrencyCode'], ParentType, ContextType>;
  hold?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reserved?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BusinessCategoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessCategory'] = ResolversParentTypes['BusinessCategory']> = ResolversObject<{
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BusinessCursorResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessCursor'] = ResolversParentTypes['BusinessCursor']> = ResolversObject<{
  edges?: Resolver<Array<ResolversTypes['BusinessEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BusinessEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessEdge'] = ResolversParentTypes['BusinessEdge']> = ResolversObject<{
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Business'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BusinessOnboardingResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOnboarding'] = ResolversParentTypes['BusinessOnboarding']> = ResolversObject<{
  address?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  bankAccountBank?: Resolver<Maybe<ResolversTypes['Bank']>, ParentType, ContextType>;
  bankAccountHolder?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  bankAccountNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['BusinessCategory']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  feeProfile?: Resolver<Maybe<ResolversTypes['FeeProfile']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ownerAddress?: Resolver<Maybe<ResolversTypes['Address']>, ParentType, ContextType>;
  ownerFirstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  ownerIdPhotos?: Resolver<Maybe<Array<ResolversTypes['Media']>>, ParentType, ContextType>;
  ownerIdType?: Resolver<Maybe<ResolversTypes['VerificationIdType']>, ParentType, ContextType>;
  ownerLastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['PhoneNumber']>, ParentType, ContextType>;
  socialMedia?: Resolver<Maybe<ResolversTypes['BusinessSocialMedia']>, ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BusinessOwnerResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessOwner'] = ResolversParentTypes['BusinessOwner']> = ResolversObject<{
  address?: Resolver<ResolversTypes['Address'], ParentType, ContextType>;
  firstName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  idPhotos?: Resolver<Array<ResolversTypes['Media']>, ParentType, ContextType>;
  idType?: Resolver<ResolversTypes['VerificationIdType'], ParentType, ContextType>;
  lastName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type BusinessSocialMediaResolvers<ContextType = any, ParentType extends ResolversParentTypes['BusinessSocialMedia'] = ResolversParentTypes['BusinessSocialMedia']> = ResolversObject<{
  facebook?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  instagram?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  snapchat?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tiktok?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  website?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CardResolvers<ContextType = any, ParentType extends ResolversParentTypes['Card'] = ResolversParentTypes['Card']> = ResolversObject<{
  flowData?: Resolver<Maybe<ResolversTypes['CardFlowData']>, ParentType, ContextType>;
  issuer?: Resolver<Maybe<ResolversTypes['CardIssuer']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type CardFlowDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['CardFlowData'] = ResolversParentTypes['CardFlowData']> = ResolversObject<{
  actionUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  referenceId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export type ErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['Error'] = ResolversParentTypes['Error']> = ResolversObject<{
  __resolveType: TypeResolveFn<'ValidationError', ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ErrorTypes'], ParentType, ContextType>;
}>;

export type FeeProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['FeeProfile'] = ResolversParentTypes['FeeProfile']> = ResolversObject<{
  code?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type GeoCoordinatesResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeoCoordinates'] = ResolversParentTypes['GeoCoordinates']> = ResolversObject<{
  lat?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  long?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ImageResolvers<ContextType = any, ParentType extends ResolversParentTypes['Image'] = ResolversParentTypes['Image']> = ResolversObject<{
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  large?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  medium?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  small?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface JsonScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['JSON'], any> {
  name: 'JSON';
}

export type LocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Location'] = ResolversParentTypes['Location']> = ResolversObject<{
  coordinates?: Resolver<ResolversTypes['GeoCoordinates'], ParentType, ContextType>;
  formattedAddress?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type LoginResolvers<ContextType = any, ParentType extends ResolversParentTypes['Login'] = ResolversParentTypes['Login']> = ResolversObject<{
  accessToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  refreshToken?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MediaResolvers<ContextType = any, ParentType extends ResolversParentTypes['Media'] = ResolversParentTypes['Media']> = ResolversObject<{
  contentType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type MoneyResolvers<ContextType = any, ParentType extends ResolversParentTypes['Money'] = ResolversParentTypes['Money']> = ResolversObject<{
  amountInCents?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  currencyCode?: Resolver<ResolversTypes['CurrencyCode'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrderResolvers<ContextType = any, ParentType extends ResolversParentTypes['Order'] = ResolversParentTypes['Order']> = ResolversObject<{
  card?: Resolver<Maybe<ResolversTypes['Card']>, ParentType, ContextType>;
  cost?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentLink?: Resolver<ResolversTypes['PaymentLink'], ParentType, ContextType>;
  paymentMode?: Resolver<ResolversTypes['OrderPaymentMode'], ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<ResolversTypes['PhoneNumber']>, ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  state?: Resolver<ResolversTypes['OrderState'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrderCursorResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderCursor'] = ResolversParentTypes['OrderCursor']> = ResolversObject<{
  edges?: Resolver<Array<ResolversTypes['OrderEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type OrderEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['OrderEdge'] = ResolversParentTypes['OrderEdge']> = ResolversObject<{
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Order'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PageInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['PageInfo'] = ResolversParentTypes['PageInfo']> = ResolversObject<{
  endCursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  entries?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  hasPrevPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  pages?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  startCursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PaymentLinkResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentLink'] = ResolversParentTypes['PaymentLink']> = ResolversObject<{
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  business?: Resolver<ResolversTypes['Business'], ParentType, ContextType>;
  cost?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  limit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PaymentLinkCursorResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentLinkCursor'] = ResolversParentTypes['PaymentLinkCursor']> = ResolversObject<{
  edges?: Resolver<Array<ResolversTypes['PaymentLinkEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PaymentLinkEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaymentLinkEdge'] = ResolversParentTypes['PaymentLinkEdge']> = ResolversObject<{
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['PaymentLink'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PayoutResolvers<ContextType = any, ParentType extends ResolversParentTypes['Payout'] = ResolversParentTypes['Payout']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  bankAccount?: Resolver<Maybe<ResolversTypes['BankAccount']>, ParentType, ContextType>;
  business?: Resolver<ResolversTypes['Business'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  mobileNumber?: Resolver<Maybe<ResolversTypes['PhoneNumber']>, ParentType, ContextType>;
  mode?: Resolver<ResolversTypes['PayoutMode'], ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['PayoutStatus'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PayoutConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutConnection'] = ResolversParentTypes['PayoutConnection']> = ResolversObject<{
  edges?: Resolver<Array<ResolversTypes['PayoutEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PayoutEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['PayoutEdge'] = ResolversParentTypes['PayoutEdge']> = ResolversObject<{
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Payout'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type PhoneNumberResolvers<ContextType = any, ParentType extends ResolversParentTypes['PhoneNumber'] = ResolversParentTypes['PhoneNumber']> = ResolversObject<{
  countryCode?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  number?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RefundResolvers<ContextType = any, ParentType extends ResolversParentTypes['Refund'] = ResolversParentTypes['Refund']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  order?: Resolver<ResolversTypes['Order'], ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['RefundStatus'], ParentType, ContextType>;
  successfulAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RefundConnectionResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundConnection'] = ResolversParentTypes['RefundConnection']> = ResolversObject<{
  edges?: Resolver<Array<ResolversTypes['RefundEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RefundEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RefundEdge'] = ResolversParentTypes['RefundEdge']> = ResolversObject<{
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Refund'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type RootMutationTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RootMutationType'] = ResolversParentTypes['RootMutationType']> = ResolversObject<{
  addOrder?: Resolver<ResolversTypes['Order'], ParentType, ContextType, RequireFields<RootMutationTypeAddOrderArgs, 'input'>>;
  addPaymentLink?: Resolver<Maybe<ResolversTypes['PaymentLink']>, ParentType, ContextType, RequireFields<RootMutationTypeAddPaymentLinkArgs, 'input'>>;
  createAdminUser?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<RootMutationTypeCreateAdminUserArgs, 'input'>>;
  createRefund?: Resolver<ResolversTypes['Refund'], ParentType, ContextType, RequireFields<RootMutationTypeCreateRefundArgs, 'input'>>;
  login?: Resolver<Maybe<ResolversTypes['Login']>, ParentType, ContextType, Partial<RootMutationTypeLoginArgs>>;
  logout?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType, Partial<RootMutationTypeLogoutArgs>>;
  refreshToken?: Resolver<Maybe<ResolversTypes['Login']>, ParentType, ContextType, Partial<RootMutationTypeRefreshTokenArgs>>;
  requestLoginOTP?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, Partial<RootMutationTypeRequestLoginOtpArgs>>;
  requestPasswordResetOTP?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<RootMutationTypeRequestPasswordResetOtpArgs, 'email'>>;
  requestPayout?: Resolver<ResolversTypes['Payout'], ParentType, ContextType, RequireFields<RootMutationTypeRequestPayoutArgs, 'input'>>;
  resendEmailVerification?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, Partial<RootMutationTypeResendEmailVerificationArgs>>;
  resendSetAdminPasswordOTP?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<RootMutationTypeResendSetAdminPasswordOtpArgs, 'email'>>;
  sendPayoutCode?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<RootMutationTypeSendPayoutCodeArgs, 'payoutId'>>;
  setAdminPassword?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<RootMutationTypeSetAdminPasswordArgs, 'input'>>;
  signup?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, Partial<RootMutationTypeSignupArgs>>;
  stepUpOrder?: Resolver<ResolversTypes['Order'], ParentType, ContextType, RequireFields<RootMutationTypeStepUpOrderArgs, 'input'>>;
  submitBusinessOnboarding?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, Partial<RootMutationTypeSubmitBusinessOnboardingArgs>>;
  updateBusiness?: Resolver<ResolversTypes['Business'], ParentType, ContextType, RequireFields<RootMutationTypeUpdateBusinessArgs, 'id' | 'input'>>;
  updateBusinessOnboarding?: Resolver<ResolversTypes['BusinessOnboarding'], ParentType, ContextType, RequireFields<RootMutationTypeUpdateBusinessOnboardingArgs, 'input'>>;
  updatePassword?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<RootMutationTypeUpdatePasswordArgs, 'input'>>;
  updatePaymentLink?: Resolver<ResolversTypes['PaymentLink'], ParentType, ContextType, RequireFields<RootMutationTypeUpdatePaymentLinkArgs, 'input'>>;
  updateUser?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<RootMutationTypeUpdateUserArgs, 'input'>>;
  uploadMedia?: Resolver<ResolversTypes['Media'], ParentType, ContextType, RequireFields<RootMutationTypeUploadMediaArgs, 'file'>>;
  verifyAndResetPasswordWithOTP?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<RootMutationTypeVerifyAndResetPasswordWithOtpArgs, 'input'>>;
  verifyEmail?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<RootMutationTypeVerifyEmailArgs, 'token'>>;
  verifyLoginOTP?: Resolver<ResolversTypes['Login'], ParentType, ContextType, RequireFields<RootMutationTypeVerifyLoginOtpArgs, 'code'>>;
  verifyPayoutCode?: Resolver<ResolversTypes['Payout'], ParentType, ContextType, RequireFields<RootMutationTypeVerifyPayoutCodeArgs, 'input'>>;
}>;

export type RootQueryTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RootQueryType'] = ResolversParentTypes['RootQueryType']> = ResolversObject<{
  activityLog?: Resolver<ResolversTypes['ActivityLog'], ParentType, ContextType, RequireFields<RootQueryTypeActivityLogArgs, 'id'>>;
  activityLogs?: Resolver<ResolversTypes['ActivityLogCursor'], ParentType, ContextType, RequireFields<RootQueryTypeActivityLogsArgs, 'input'>>;
  banks?: Resolver<Array<ResolversTypes['Bank']>, ParentType, ContextType>;
  business?: Resolver<Maybe<ResolversTypes['Business']>, ParentType, ContextType, Partial<RootQueryTypeBusinessArgs>>;
  businessCategories?: Resolver<Array<ResolversTypes['BusinessCategory']>, ParentType, ContextType>;
  businessOnboarding?: Resolver<Maybe<ResolversTypes['BusinessOnboarding']>, ParentType, ContextType, Partial<RootQueryTypeBusinessOnboardingArgs>>;
  businesses?: Resolver<ResolversTypes['BusinessCursor'], ParentType, ContextType, RequireFields<RootQueryTypeBusinessesArgs, 'input'>>;
  error?: Resolver<Maybe<ResolversTypes['ValidationError']>, ParentType, ContextType>;
  feeProfiles?: Resolver<Array<ResolversTypes['FeeProfile']>, ParentType, ContextType>;
  me?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType>;
  order?: Resolver<ResolversTypes['Order'], ParentType, ContextType, Partial<RootQueryTypeOrderArgs>>;
  orders?: Resolver<ResolversTypes['OrderCursor'], ParentType, ContextType, RequireFields<RootQueryTypeOrdersArgs, 'input'>>;
  paymentLink?: Resolver<ResolversTypes['PaymentLink'], ParentType, ContextType, Partial<RootQueryTypePaymentLinkArgs>>;
  paymentLinks?: Resolver<ResolversTypes['PaymentLinkCursor'], ParentType, ContextType, RequireFields<RootQueryTypePaymentLinksArgs, 'input'>>;
  payout?: Resolver<ResolversTypes['Payout'], ParentType, ContextType, RequireFields<RootQueryTypePayoutArgs, 'id'>>;
  payouts?: Resolver<ResolversTypes['PayoutConnection'], ParentType, ContextType, RequireFields<RootQueryTypePayoutsArgs, 'input'>>;
  refund?: Resolver<ResolversTypes['Refund'], ParentType, ContextType, Partial<RootQueryTypeRefundArgs>>;
  refunds?: Resolver<ResolversTypes['RefundConnection'], ParentType, ContextType, RequireFields<RootQueryTypeRefundsArgs, 'input'>>;
  transaction?: Resolver<ResolversTypes['Transaction'], ParentType, ContextType, RequireFields<RootQueryTypeTransactionArgs, 'id'>>;
  transactions?: Resolver<ResolversTypes['TransactionCursor'], ParentType, ContextType, RequireFields<RootQueryTypeTransactionsArgs, 'input'>>;
  user?: Resolver<ResolversTypes['User'], ParentType, ContextType, RequireFields<RootQueryTypeUserArgs, 'id'>>;
  users?: Resolver<ResolversTypes['UserCursor'], ParentType, ContextType, RequireFields<RootQueryTypeUsersArgs, 'input'>>;
}>;

export type RootSubscriptionTypeResolvers<ContextType = any, ParentType extends ResolversParentTypes['RootSubscriptionType'] = ResolversParentTypes['RootSubscriptionType']> = ResolversObject<{
  order?: SubscriptionResolver<ResolversTypes['Order'], "order", ParentType, ContextType, Partial<RootSubscriptionTypeOrderArgs>>;
  orders?: SubscriptionResolver<ResolversTypes['OrderCursor'], "orders", ParentType, ContextType, RequireFields<RootSubscriptionTypeOrdersArgs, 'input'>>;
  paymentLink?: SubscriptionResolver<ResolversTypes['PaymentLink'], "paymentLink", ParentType, ContextType, Partial<RootSubscriptionTypePaymentLinkArgs>>;
}>;

export type SettlementInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['SettlementInfo'] = ResolversParentTypes['SettlementInfo']> = ResolversObject<{
  amount?: Resolver<Maybe<ResolversTypes['Money']>, ParentType, ContextType>;
  date?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  settled?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TargetEntityUnionResolvers<ContextType = any, ParentType extends ResolversParentTypes['TargetEntityUnion'] = ResolversParentTypes['TargetEntityUnion']> = ResolversObject<{
  __resolveType: TypeResolveFn<'Business' | 'BusinessCategory' | 'Order' | 'PaymentLink' | 'Payout' | 'User', ParentType, ContextType>;
}>;

export interface TimeInHmScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['TimeInHm'], any> {
  name: 'TimeInHm';
}

export type TransactionResolvers<ContextType = any, ParentType extends ResolversParentTypes['Transaction'] = ResolversParentTypes['Transaction']> = ResolversObject<{
  amount?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  business?: Resolver<ResolversTypes['Business'], ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  fee?: Resolver<ResolversTypes['Money'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  paymentProvider?: Resolver<Maybe<ResolversTypes['PaymentProvider']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reference?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['TransactionStatus'], ParentType, ContextType>;
  transactionCard?: Resolver<Maybe<ResolversTypes['TransactionCard']>, ParentType, ContextType>;
  transactionMpesa?: Resolver<Maybe<ResolversTypes['TransactionMpesa']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TransactionCardResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransactionCard'] = ResolversParentTypes['TransactionCard']> = ResolversObject<{
  cardSource?: Resolver<Maybe<ResolversTypes['CardSource']>, ParentType, ContextType>;
  issuer?: Resolver<Maybe<ResolversTypes['CardIssuer']>, ParentType, ContextType>;
  number?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  settlementInfo?: Resolver<Maybe<ResolversTypes['SettlementInfo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TransactionCursorResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransactionCursor'] = ResolversParentTypes['TransactionCursor']> = ResolversObject<{
  edges?: Resolver<Array<ResolversTypes['TransactionEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TransactionEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransactionEdge'] = ResolversParentTypes['TransactionEdge']> = ResolversObject<{
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['Transaction'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type TransactionMpesaResolvers<ContextType = any, ParentType extends ResolversParentTypes['TransactionMpesa'] = ResolversParentTypes['TransactionMpesa']> = ResolversObject<{
  phoneNumber?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export interface UploadScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['Upload'], any> {
  name: 'Upload';
}

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = ResolversObject<{
  businesses?: Resolver<Array<ResolversTypes['Business']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  emailVerifiedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<Maybe<ResolversTypes['ID']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  logo?: Resolver<Maybe<ResolversTypes['Image']>, ParentType, ContextType>;
  phone?: Resolver<Maybe<ResolversTypes['PhoneNumber']>, ParentType, ContextType>;
  roles?: Resolver<Array<ResolversTypes['UserRole']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['UserStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserCursorResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserCursor'] = ResolversParentTypes['UserCursor']> = ResolversObject<{
  edges?: Resolver<Array<ResolversTypes['UserEdge']>, ParentType, ContextType>;
  pageInfo?: Resolver<ResolversTypes['PageInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type UserEdgeResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserEdge'] = ResolversParentTypes['UserEdge']> = ResolversObject<{
  cursor?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  node?: Resolver<ResolversTypes['User'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type ValidationErrorResolvers<ContextType = any, ParentType extends ResolversParentTypes['ValidationError'] = ResolversParentTypes['ValidationError']> = ResolversObject<{
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['ErrorTypes'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type VerificationCodeResolvers<ContextType = any, ParentType extends ResolversParentTypes['VerificationCode'] = ResolversParentTypes['VerificationCode']> = ResolversObject<{
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  expiresAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['VerificationCodeStatus'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
}>;

export type Resolvers<ContextType = any> = ResolversObject<{
  ActivityLog?: ActivityLogResolvers<ContextType>;
  ActivityLogCursor?: ActivityLogCursorResolvers<ContextType>;
  ActivityLogEdge?: ActivityLogEdgeResolvers<ContextType>;
  Address?: AddressResolvers<ContextType>;
  Bank?: BankResolvers<ContextType>;
  BankAccount?: BankAccountResolvers<ContextType>;
  Business?: BusinessResolvers<ContextType>;
  BusinessBalance?: BusinessBalanceResolvers<ContextType>;
  BusinessCategory?: BusinessCategoryResolvers<ContextType>;
  BusinessCursor?: BusinessCursorResolvers<ContextType>;
  BusinessEdge?: BusinessEdgeResolvers<ContextType>;
  BusinessOnboarding?: BusinessOnboardingResolvers<ContextType>;
  BusinessOwner?: BusinessOwnerResolvers<ContextType>;
  BusinessSocialMedia?: BusinessSocialMediaResolvers<ContextType>;
  Card?: CardResolvers<ContextType>;
  CardFlowData?: CardFlowDataResolvers<ContextType>;
  DateTime?: GraphQLScalarType;
  Error?: ErrorResolvers<ContextType>;
  FeeProfile?: FeeProfileResolvers<ContextType>;
  GeoCoordinates?: GeoCoordinatesResolvers<ContextType>;
  Image?: ImageResolvers<ContextType>;
  JSON?: GraphQLScalarType;
  Location?: LocationResolvers<ContextType>;
  Login?: LoginResolvers<ContextType>;
  Media?: MediaResolvers<ContextType>;
  Money?: MoneyResolvers<ContextType>;
  Order?: OrderResolvers<ContextType>;
  OrderCursor?: OrderCursorResolvers<ContextType>;
  OrderEdge?: OrderEdgeResolvers<ContextType>;
  PageInfo?: PageInfoResolvers<ContextType>;
  PaymentLink?: PaymentLinkResolvers<ContextType>;
  PaymentLinkCursor?: PaymentLinkCursorResolvers<ContextType>;
  PaymentLinkEdge?: PaymentLinkEdgeResolvers<ContextType>;
  Payout?: PayoutResolvers<ContextType>;
  PayoutConnection?: PayoutConnectionResolvers<ContextType>;
  PayoutEdge?: PayoutEdgeResolvers<ContextType>;
  PhoneNumber?: PhoneNumberResolvers<ContextType>;
  Refund?: RefundResolvers<ContextType>;
  RefundConnection?: RefundConnectionResolvers<ContextType>;
  RefundEdge?: RefundEdgeResolvers<ContextType>;
  RootMutationType?: RootMutationTypeResolvers<ContextType>;
  RootQueryType?: RootQueryTypeResolvers<ContextType>;
  RootSubscriptionType?: RootSubscriptionTypeResolvers<ContextType>;
  SettlementInfo?: SettlementInfoResolvers<ContextType>;
  TargetEntityUnion?: TargetEntityUnionResolvers<ContextType>;
  TimeInHm?: GraphQLScalarType;
  Transaction?: TransactionResolvers<ContextType>;
  TransactionCard?: TransactionCardResolvers<ContextType>;
  TransactionCursor?: TransactionCursorResolvers<ContextType>;
  TransactionEdge?: TransactionEdgeResolvers<ContextType>;
  TransactionMpesa?: TransactionMpesaResolvers<ContextType>;
  Upload?: GraphQLScalarType;
  User?: UserResolvers<ContextType>;
  UserCursor?: UserCursorResolvers<ContextType>;
  UserEdge?: UserEdgeResolvers<ContextType>;
  ValidationError?: ValidationErrorResolvers<ContextType>;
  VerificationCode?: VerificationCodeResolvers<ContextType>;
}>;

export type DirectiveResolvers<ContextType = any> = ResolversObject<{
  authenticated?: AuthenticatedDirectiveResolver<any, any, ContextType>;
}>;
